(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
!function(e,o){if("function"==typeof define&&define.amd)define(["exports"],o);else if("undefined"!=typeof exports)o(exports);else{var t={};o(t),e.bodyScrollLock=t}}(this,function(exports){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var t=!1;if("undefined"!=typeof window){var e={get passive(){t=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}function l(o){return c.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(o))})}function d(e){var o=e||window.event;return!!l(o.target)||(1<o.touches.length||(o.preventDefault&&o.preventDefault(),!1))}function n(){void 0!==v&&(document.body.style.paddingRight=v,v=void 0),void 0!==s&&(document.body.style.overflow=s,s=void 0)}var i="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&1<window.navigator.maxTouchPoints),c=[],a=!1,u=-1,s=void 0,v=void 0;exports.disableBodyScroll=function(r,e){if(r){if(!c.some(function(e){return e.targetElement===r})){var o={targetElement:r,options:e||{}};c=[].concat(function(e){if(Array.isArray(e)){for(var o=0,t=Array(e.length);o<e.length;o++)t[o]=e[o];return t}return Array.from(e)}(c),[o]),i?(r.ontouchstart=function(e){1===e.targetTouches.length&&(u=e.targetTouches[0].clientY)},r.ontouchmove=function(e){var o,t,n,i;1===e.targetTouches.length&&(t=r,i=(o=e).targetTouches[0].clientY-u,l(o.target)||(t&&0===t.scrollTop&&0<i||(n=t)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&i<0?d(o):o.stopPropagation()))},a||(document.addEventListener("touchmove",d,t?{passive:!1}:void 0),a=!0)):function(e){if(void 0===v){var o=!!e&&!0===e.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;o&&0<t&&(v=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===s&&(s=document.body.style.overflow,document.body.style.overflow="hidden")}(e)}}else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.")},exports.clearAllBodyScrollLocks=function(){i?(c.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),a&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1),u=-1):n(),c=[]},exports.enableBodyScroll=function(o){o?(c=c.filter(function(e){return e.targetElement!==o}),i?(o.ontouchstart=null,o.ontouchmove=null,a&&0===c.length&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1)):c.length||n()):console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.")}});

},{}],2:[function(require,module,exports){
!function(t,e){if("object"==typeof exports&&"object"==typeof module)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var n=e();for(var r in n)("object"==typeof exports?exports:t)[r]=n[r]}}(window,function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var i=e[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(r,i,function(e){return t[e]}.bind(null,i));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=3)}([function(t,e,n){var r,i;
/*!
 * imagesLoaded v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */
/*!
 * imagesLoaded v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */
!function(o,s){"use strict";r=[n(2)],void 0===(i=function(t){return function(t,e){var n=t.jQuery,r=t.console;function i(t,e){for(var n in e)t[n]=e[n];return t}var o=Array.prototype.slice;function s(t,e,a){if(!(this instanceof s))return new s(t,e,a);var u=t;"string"==typeof t&&(u=document.querySelectorAll(t)),u?(this.elements=function(t){if(Array.isArray(t))return t;if("object"==typeof t&&"number"==typeof t.length)return o.call(t);return[t]}(u),this.options=i({},this.options),"function"==typeof e?a=e:i(this.options,e),a&&this.on("always",a),this.getImages(),n&&(this.jqDeferred=new n.Deferred),setTimeout(this.check.bind(this))):r.error("Bad element for imagesLoaded "+(u||t))}s.prototype=Object.create(e.prototype),s.prototype.options={},s.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},s.prototype.addElementImages=function(t){"IMG"==t.nodeName&&this.addImage(t),!0===this.options.background&&this.addElementBackgroundImages(t);var e=t.nodeType;if(e&&a[e]){for(var n=t.querySelectorAll("img"),r=0;r<n.length;r++){var i=n[r];this.addImage(i)}if("string"==typeof this.options.background){var o=t.querySelectorAll(this.options.background);for(r=0;r<o.length;r++){var s=o[r];this.addElementBackgroundImages(s)}}}};var a={1:!0,9:!0,11:!0};function u(t){this.img=t}function c(t,e){this.url=t,this.element=e,this.img=new Image}return s.prototype.addElementBackgroundImages=function(t){var e=getComputedStyle(t);if(e)for(var n=/url\((['"])?(.*?)\1\)/gi,r=n.exec(e.backgroundImage);null!==r;){var i=r&&r[2];i&&this.addBackground(i,t),r=n.exec(e.backgroundImage)}},s.prototype.addImage=function(t){var e=new u(t);this.images.push(e)},s.prototype.addBackground=function(t,e){var n=new c(t,e);this.images.push(n)},s.prototype.check=function(){var t=this;function e(e,n,r){setTimeout(function(){t.progress(e,n,r)})}this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?this.images.forEach(function(t){t.once("progress",e),t.check()}):this.complete()},s.prototype.progress=function(t,e,n){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!t.isLoaded,this.emitEvent("progress",[this,t,e]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,t),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&r&&r.log("progress: "+n,t,e)},s.prototype.complete=function(){var t=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(t,[this]),this.emitEvent("always",[this]),this.jqDeferred){var e=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[e](this)}},u.prototype=Object.create(e.prototype),u.prototype.check=function(){this.getIsImageComplete()?this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.proxyImage.src=this.img.src)},u.prototype.getIsImageComplete=function(){return this.img.complete&&this.img.naturalWidth},u.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.img,e])},u.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},u.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},u.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},u.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},c.prototype=Object.create(u.prototype),c.prototype.check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url,this.getIsImageComplete()&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},c.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},c.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.element,e])},s.makeJQueryPlugin=function(e){(e=e||t.jQuery)&&((n=e).fn.imagesLoaded=function(t,e){return new s(this,t,e).jqDeferred.promise(n(this))})},s.makeJQueryPlugin(),s}(o,t)}.apply(e,r))||(t.exports=i)}("undefined"!=typeof window?window:this)},function(t,e){function n(t,e,n,r){var i,o=null==(i=r)||"number"==typeof i||"boolean"==typeof i?r:n(r),s=e.get(o);return void 0===s&&(s=t.call(this,r),e.set(o,s)),s}function r(t,e,n){var r=Array.prototype.slice.call(arguments,3),i=n(r),o=e.get(i);return void 0===o&&(o=t.apply(this,r),e.set(i,o)),o}function i(t,e,n,r,i){return n.bind(e,t,r,i)}function o(t,e){return i(t,this,1===t.length?n:r,e.cache.create(),e.serializer)}function s(){return JSON.stringify(arguments)}function a(){this.cache=Object.create(null)}a.prototype.has=function(t){return t in this.cache},a.prototype.get=function(t){return this.cache[t]},a.prototype.set=function(t,e){this.cache[t]=e};var u={create:function(){return new a}};t.exports=function(t,e){var n=e&&e.cache?e.cache:u,r=e&&e.serializer?e.serializer:s;return(e&&e.strategy?e.strategy:o)(t,{cache:n,serializer:r})},t.exports.strategies={variadic:function(t,e){return i(t,this,r,e.cache.create(),e.serializer)},monadic:function(t,e){return i(t,this,n,e.cache.create(),e.serializer)}}},function(t,e,n){var r,i;"undefined"!=typeof window&&window,void 0===(i="function"==typeof(r=function(){"use strict";function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var n=this._events=this._events||{},r=n[t]=n[t]||[];return-1==r.indexOf(e)&&r.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var n=this._onceEvents=this._onceEvents||{};return(n[t]=n[t]||{})[e]=!0,this}},e.off=function(t,e){var n=this._events&&this._events[t];if(n&&n.length){var r=n.indexOf(e);return-1!=r&&n.splice(r,1),this}},e.emitEvent=function(t,e){var n=this._events&&this._events[t];if(n&&n.length){n=n.slice(0),e=e||[];for(var r=this._onceEvents&&this._onceEvents[t],i=0;i<n.length;i++){var o=n[i];r&&r[o]&&(this.off(t,o),delete r[o]),o.apply(this,e)}return this}},e.allOff=function(){delete this._events,delete this._onceEvents},t})?r.call(e,n,e,t):r)||(t.exports=i)},function(t,e,n){"use strict";n.r(e);var r={IDLE:"IDLE",FILTERING:"FILTERING",SORTING:"SORTING",SHUFFLING:"SHUFFLING"},i={SAME_SIZE:"sameSize",SAME_HEIGHT:"sameHeight",SAME_WIDTH:"sameWidth",PACKED:"packed",HORIZONTAL:"horizontal",VERTICAL:"vertical"},o=/(^linear$)|(^ease-in-out$)|(^ease-in$)|(^ease-out$)|(^ease$)|(^step-start$)|(^step-end$)|(^steps\(\d\s*,\s*(end|start)\))$|(^cubic-bezier\((\d*\.*\d+)\s*,\s*(\d*\.*\d+)\s*,\s*(\d*\.*\d+)\s*,\s*(\d*\.*\d+)\))$/,s=function(t,e,n,r,i){if(void 0!==e){var o=new Error('Filterizr: expected type of option "'+t+'" to be "'+n+'", but its type is: "'+typeof e+'"'),s=!1,a=!1,u=n.includes("array");if((typeof e).match(n)?s=!0:!s&&u&&(a=Array.isArray(e)),!s&&!u)throw o;if(!s&&u&&!a)throw o;var c=function(t){return t?" For further help read here: "+t:""};if(Array.isArray(r)){var l=!1;if(r.forEach(function(t){t===e&&(l=!0)}),!l)throw new Error('Filterizr: allowed values for option "'+t+'" are: '+r.map(function(t){return'"'+t+'"'}).join(", ")+'. Value received: "'+e+'".'+c(i))}else if("string"==typeof e&&r instanceof RegExp){if(!e.match(r))throw new Error('Filterizr: invalid value "'+e+'" for option "'+t+'" received.'+c(i))}}},a=function(t,e,n){var r;return function(){var i=this,o=arguments;clearTimeout(r),r=window.setTimeout(function(){r=null,n||t.apply(i,o)},e),n&&!r&&t.apply(i,o)}},u=function(t,e){return t.length===e.length&&t.reduce(function(t,n,r){var i=n.getSortAttribute("index"),o=e[r].getSortAttribute("index");return t&&i===o},!0)};var c=function(t){return"string"==typeof t?document.querySelector(t):t};function l(t){return t&&"object"==typeof t&&!Array.isArray(t)}function f(t){for(var e,n,r=[],i=1;i<arguments.length;i++)r[i-1]=arguments[i];if(!r.length)return t;var o=r.shift();if(l(t)&&l(o))for(var s in o)l(o[s])?(t[s]||Object.assign(t,((e={})[s]={},e)),f(t[s],o[s])):Object.assign(t,((n={})[s]=o[s],n));return f.apply(void 0,[t].concat(r))}var h=function(){};function p(t,e){Object.entries(e).forEach(function(e){var n=e[0],r=e[1];t.style[n]=r})}var d=function(t){for(var e=t.slice(0),n=[];0!==e.length;){var r=Math.floor(e.length*Math.random());n.push(e[r]),e.splice(r,1)}return n},y=function(){function t(t){this.receiver=t,this.eventDictionary={}}return t.prototype.on=function(t,e){var n=this.receiver,r=n instanceof NodeList;!!this.eventDictionary[t]&&delete this.eventDictionary[t],r&&n.length?(this.eventDictionary[t]=e,Array.from(n).forEach(function(n){n.addEventListener(t,e)})):!r&&n&&(this.eventDictionary[t]=e,n.addEventListener(t,e))},t.prototype.off=function(t){var e=this.receiver,n=this.eventDictionary[t],r=e instanceof NodeList;r&&e.length?Array.from(e).forEach(function(e){e.removeEventListener(t,n)}):!r&&e&&e.removeEventListener(t,n),delete this.eventDictionary[t]},t.prototype.destroy=function(){var t=this,e=this.receiver,n=e instanceof NodeList;n&&e.length?Array.from(e).forEach(function(e){return t.removeAllEvents(e)}):!n&&e&&this.removeAllEvents(e)},t.prototype.removeAllEvents=function(t){var e=this;Object.keys(this.eventDictionary).forEach(function(n){t.removeEventListener(n,e.eventDictionary[n]),delete e.eventDictionary[n]})},t}(),v={animationDuration:.5,callbacks:{onInit:h,onFilteringStart:h,onFilteringEnd:h,onShufflingStart:h,onShufflingEnd:h,onSortingStart:h,onSortingEnd:h},controlsSelector:"",delay:0,delayMode:"progressive",easing:"ease-out",filter:"all",filterOutCss:{opacity:0,transform:"scale(0.5)"},filterInCss:{opacity:1,transform:"scale(1)"},gridItemsSelector:".filtr-item",gutterPixels:0,layout:i.SAME_SIZE,multifilterLogicalOperator:"or",searchTerm:"",setupControls:!0,spinner:{enabled:!1,fillColor:"#2184D0",styles:{height:"75px",margin:"0 auto",width:"75px","z-index":2}}},g=function(){function t(t){this.filter=t}return t.prototype.get=function(){return this.filter},t.prototype.set=function(t){this.filter=t},t.prototype.toggle=function(t){this.filter=this.toggleFilter(this.filter,t)},t.prototype.toggleFilter=function(t,e){if("all"===t)return e;if(Array.isArray(t)){if(t.includes(e)){var n=t.filter(function(t){return t!==e});return 1===n.length?n[0]:n}return t.concat([e])}return t===e?"all":[t,e]},t}(),m=function(){return(m=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var i in e=arguments[n])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t}).apply(this,arguments)},b=function(){function t(t){var e=f({},v,this.validate(t));this.options=this.convertToFilterizrOptions(e)}return Object.defineProperty(t.prototype,"isSpinnerEnabled",{get:function(){return this.options.spinner.enabled},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"areControlsEnabled",{get:function(){return this.options.setupControls},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"controlsSelector",{get:function(){return this.options.controlsSelector},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"filter",{get:function(){return this.options.filter.get()},set:function(t){this.options.filter.set(t)},enumerable:!0,configurable:!0}),t.prototype.toggleFilter=function(t){this.options.filter.toggle(t)},Object.defineProperty(t.prototype,"searchTerm",{get:function(){return this.options.searchTerm},set:function(t){this.options.searchTerm=t},enumerable:!0,configurable:!0}),t.prototype.get=function(){return this.options},t.prototype.getRaw=function(){return this.convertToOptions(this.options)},t.prototype.set=function(t){var e=f({},this.convertToOptions(this.options),this.validate(t));this.options=this.convertToFilterizrOptions(e)},t.prototype.convertToFilterizrOptions=function(t){return m({},t,{filter:new g(t.filter)})},t.prototype.convertToOptions=function(t){return m({},t,{filter:t.filter.get()})},t.prototype.validate=function(t){return s("animationDuration",t.animationDuration,"number"),s("callbacks",t.callbacks,"object"),s("controlsSelector",t.controlsSelector,"string"),s("delay",t.delay,"number"),s("easing",t.easing,"string",o,"https://www.w3schools.com/cssref/css3_pr_transition-timing-function.asp"),s("delayMode",t.delayMode,"string",["progressive","alternate"]),s("filter",t.filter,"string|number|array"),s("filterOutCss",t.filterOutCss,"object"),s("filterInCss",t.filterOutCss,"object"),s("gridItemsSelector",t.gridItemsSelector,"string"),s("gutterPixels",t.gutterPixels,"number"),s("layout",t.layout,"string",Object.values(i)),s("multifilterLogicalOperator",t.multifilterLogicalOperator,"string",["and","or"]),s("searchTerm",t.searchTerm,"string"),s("setupControls",t.setupControls,"boolean"),t},t}(),w=function(){function t(t,e){void 0===e&&(e=""),this.filterizr=t,this.selector=e,this.filterControls=new y(document.querySelectorAll(e+"[data-filter]")),this.multiFilterControls=new y(document.querySelectorAll(e+"[data-multifilter]")),this.shuffleControls=new y(document.querySelectorAll(e+"[data-shuffle]")),this.searchControls=new y(document.querySelectorAll(e+"[data-search]")),this.sortAscControls=new y(document.querySelectorAll(e+"[data-sortAsc]")),this.sortDescControls=new y(document.querySelectorAll(e+"[data-sortDesc]")),this.initialize()}return t.prototype.destroy=function(){this.filterControls.destroy(),this.multiFilterControls.destroy(),this.shuffleControls.destroy(),this.searchControls.destroy(),this.sortAscControls.destroy(),this.sortDescControls.destroy()},t.prototype.initialize=function(){var t=this.filterizr,e=this.selector;this.filterControls.on("click",function(e){var n=e.currentTarget.getAttribute("data-filter");t.filter(n)}),this.multiFilterControls.on("click",function(e){var n=e.target.getAttribute("data-multifilter");t.toggleFilter(n)}),this.shuffleControls.on("click",t.shuffle.bind(t)),this.searchControls.on("keyup",a(function(e){var n=e.target.value;t.search(n)},250,!1)),this.sortAscControls.on("click",function(){var n=document.querySelector(e+"[data-sortOrder]").value;t.sort(n,"asc")}),this.sortDescControls.on("click",function(){var n=document.querySelector(e+"[data-sortOrder]").value;t.sort(n,"desc")})},t}(),E=function(){function t(t,e){this.node=t,this.options=e,this.eventReceiver=new y(this.node)}return Object.defineProperty(t.prototype,"dimensions",{get:function(){return{width:this.node.clientWidth,height:this.node.clientHeight}},enumerable:!0,configurable:!0}),t.prototype.destroy=function(){this.styles.destroy()},t.prototype.trigger=function(t){var e=new Event(t);this.node.dispatchEvent(e)},t}();function I(t,e){var n=e.get(),r=n.delay;return"progressive"===n.delayMode?r*t:t%2==0?r:0}var S,O=function(t,e,n,r){return new(n||(n=Promise))(function(i,o){function s(t){try{u(r.next(t))}catch(t){o(t)}}function a(t){try{u(r.throw(t))}catch(t){o(t)}}function u(t){t.done?i(t.value):new n(function(e){e(t.value)}).then(s,a)}u((r=r.apply(t,e||[])).next())})},x=function(t,e){var n,r,i,o,s={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(o){return function(a){return function(o){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,r&&(i=2&o[0]?r.return:o[0]?r.throw||((i=r.return)&&i.call(r),0):r.next)&&!(i=i.call(r,o[1])).done)return i;switch(r=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,r=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!(i=(i=s.trys).length>0&&i[i.length-1])&&(6===o[0]||2===o[0])){s=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){s.label=o[1];break}if(6===o[0]&&s.label<i[1]){s.label=i[1],i=o;break}if(i&&s.label<i[2]){s.label=i[2],s.ops.push(o);break}i[2]&&s.ops.pop(),s.trys.pop();continue}o=e.call(t,s)}catch(t){o=[6,t],r=0}finally{n=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,a])}}},_=function(){function t(){}return t.animate=function(e,n){return O(this,void 0,void 0,function(){return x(this,function(r){switch(r.label){case 0:return[4,t.process({node:e,targetStyles:n,eventReceiver:new y(e)})];case 1:return r.sent(),[2]}})})},t.process=function(t){return O(this,void 0,void 0,function(){return x(this,function(e){return[2,new Promise(function(e){t.eventReceiver.on("transitionend",function(){t.eventReceiver.destroy(),e()}),setTimeout(function(){p(t.node,t.targetStyles)},10)})]})})},t}().animate,k=function(t,e,n,r){return new(n||(n=Promise))(function(i,o){function s(t){try{u(r.next(t))}catch(t){o(t)}}function a(t){try{u(r.throw(t))}catch(t){o(t)}}function u(t){t.done?i(t.value):new n(function(e){e(t.value)}).then(s,a)}u((r=r.apply(t,e||[])).next())})},C=function(t,e){var n,r,i,o,s={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(o){return function(a){return function(o){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,r&&(i=2&o[0]?r.return:o[0]?r.throw||((i=r.return)&&i.call(r),0):r.next)&&!(i=i.call(r,o[1])).done)return i;switch(r=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,r=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!(i=(i=s.trys).length>0&&i[i.length-1])&&(6===o[0]||2===o[0])){s=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){s.label=o[1];break}if(6===o[0]&&s.label<i[1]){s.label=i[1],i=o;break}if(i&&s.label<i[2]){s.label=i[2],s.ops.push(o);break}i[2]&&s.ops.pop(),s.trys.pop();continue}o=e.call(t,s)}catch(t){o=[6,t],r=0}finally{n=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,a])}}},A=function(){function t(t,e){this.node=t,this.options=e}return t.prototype.destroy=function(){this.node.removeAttribute("style")},t.prototype.animate=function(t){return k(this,void 0,void 0,function(){return C(this,function(e){return _(this.node,t),[2]})})},t.prototype.set=function(t){p(this.node,t)},t.prototype.remove=function(t){this.node.style.removeProperty(t)},t}(),T=(S=function(t,e){return(S=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])})(t,e)},function(t,e){function n(){this.constructor=t}S(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)}),j=function(t,e,n,r){return new(n||(n=Promise))(function(i,o){function s(t){try{u(r.next(t))}catch(t){o(t)}}function a(t){try{u(r.throw(t))}catch(t){o(t)}}function u(t){t.done?i(t.value):new n(function(e){e(t.value)}).then(s,a)}u((r=r.apply(t,e||[])).next())})},P=function(t,e){var n,r,i,o,s={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(o){return function(a){return function(o){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,r&&(i=2&o[0]?r.return:o[0]?r.throw||((i=r.return)&&i.call(r),0):r.next)&&!(i=i.call(r,o[1])).done)return i;switch(r=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,r=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!(i=(i=s.trys).length>0&&i[i.length-1])&&(6===o[0]||2===o[0])){s=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){s.label=o[1];break}if(6===o[0]&&s.label<i[1]){s.label=i[1],i=o;break}if(i&&s.label<i[2]){s.label=i[2],s.ops.push(o);break}i[2]&&s.ops.pop(),s.trys.pop();continue}o=e.call(t,s)}catch(t){o=[6,t],r=0}finally{n=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,a])}}},F=n(0),L=function(t){function e(e,n,r){var i=t.call(this,e,r)||this;return i._index=n,i}return T(e,t),e.prototype.initialize=function(){var t;this.set((t=this.options,Object.assign({},t.get().filterOutCss,{"-webkit-backface-visibility":"hidden",perspective:"1000px","-webkit-perspective":"1000px","-webkit-transform-style":"preserve-3d",position:"absolute"})))},e.prototype.setFilteredStyles=function(t,e){this.set(function(t,e){return Object.assign({},e,{transform:(e.transform||"")+" translate3d("+t.left+"px, "+t.top+"px, 0)"})}(t,e))},e.prototype.updateTransitionStyle=function(){var t,e,n;this.set((t=this._index,e=this.options,{transition:"all "+(n=e.get()).animationDuration+"s "+n.easing+" "+I(t,e)+"ms, width 1ms"}))},e.prototype.updateWidth=function(){var t=this.options.get().gutterPixels,e=this.node.parentElement.clientWidth,n=this.node.clientWidth,r=n-t*(1/Math.floor(e/n)+1)+"px";this.set({width:r})},e.prototype.enableTransitions=function(){return j(this,void 0,void 0,function(){var t=this;return P(this,function(e){return[2,new Promise(function(e){!!t.node.querySelectorAll("img").length?F(t.node,function(){setTimeout(function(){t.updateTransitionStyle(),e()},10)}):setTimeout(function(){t.updateTransitionStyle(),e()},10)})]})})},e.prototype.disableTransitions=function(){this.remove("transition")},e.prototype.setZIndex=function(t){this.set({"z-index":t})},e.prototype.removeZIndex=function(){this.remove("z-index")},e.prototype.removeWidth=function(){this.remove("width")},e.prototype.setHidden=function(){this.set({display:"none"})},e.prototype.setVisible=function(){this.remove("display")},e}(A),z=function(){var t=function(e,n){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])})(e,n)};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}(),D=function(){return(D=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var i in e=arguments[n])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t}).apply(this,arguments)},N=function(t){function e(e,n,r){var i=t.call(this,e,r)||this;return i.filteredOut=!1,i.lastPosition={left:0,top:0},i.sortData=D({},function(t){for(var e={category:"",sort:""},n=0,r=t.attributes,i=r.length;n<i;n++){var o=r[n],s=o.nodeName,a=o.nodeValue;s.includes("data")&&(e[s.slice(5,s.length)]=a)}return delete e.category,delete e.sort,e}(e),{index:n,sortData:e.getAttribute("data-sort")}),i.styledNode=new L(e,n,r),i.styles.initialize(),i.bindEvents(),i}return z(e,t),Object.defineProperty(e.prototype,"styles",{get:function(){return this.styledNode},enumerable:!0,configurable:!0}),e.prototype.destroy=function(){t.prototype.destroy.call(this),this.unbindEvents()},e.prototype.filterIn=function(t){var e=this.options.get().filterInCss;this.styles.setFilteredStyles(t,e),this.lastPosition=t,this.filteredOut=!1},e.prototype.filterOut=function(){var t=this.options.get().filterOutCss;this.styles.setFilteredStyles(this.lastPosition,t),this.filteredOut=!0},e.prototype.contentsMatchSearch=function(t){return this.node.textContent.toLowerCase().includes(t)},e.prototype.getCategories=function(){return this.node.getAttribute("data-category").split(/\s*,\s*/g)},e.prototype.getSortAttribute=function(t){return this.sortData[t]},e.prototype.bindEvents=function(){var t=this;this.eventReceiver.on("transitionend",function(){t.filteredOut?(t.node.classList.add("filteredOut"),t.styles.setZIndex(-1e3),t.styles.setHidden()):(t.node.classList.remove("filteredOut"),t.styles.removeZIndex())})},e.prototype.unbindEvents=function(){this.eventReceiver.off("transitionend")},e}(E),M=function(){},R=function(){var t=function(e,n){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])})(e,n)};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}(),H=function(t,e,n,r){return new(n||(n=Promise))(function(i,o){function s(t){try{u(r.next(t))}catch(t){o(t)}}function a(t){try{u(r.throw(t))}catch(t){o(t)}}function u(t){t.done?i(t.value):new n(function(e){e(t.value)}).then(s,a)}u((r=r.apply(t,e||[])).next())})},W=function(t,e){var n,r,i,o,s={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(o){return function(a){return function(o){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,r&&(i=2&o[0]?r.return:o[0]?r.throw||((i=r.return)&&i.call(r),0):r.next)&&!(i=i.call(r,o[1])).done)return i;switch(r=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,r=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!(i=(i=s.trys).length>0&&i[i.length-1])&&(6===o[0]||2===o[0])){s=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){s.label=o[1];break}if(6===o[0]&&s.label<i[1]){s.label=i[1],i=o;break}if(i&&s.label<i[2]){s.label=i[2],s.ops.push(o);break}i[2]&&s.ops.pop(),s.trys.pop();continue}o=e.call(t,s)}catch(t){o=[6,t],r=0}finally{n=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,a])}}},q=function(t){function e(e){var n=t.call(this)||this;return n._filterItems=e.map(function(t){return t.styles}),n}return R(e,t),e.prototype.resetDisplay=function(){this._filterItems.forEach(function(t){return t.setVisible()})},e.prototype.removeWidth=function(){this._filterItems.forEach(function(t){return t.removeWidth()})},e.prototype.updateWidth=function(){this._filterItems.forEach(function(t){return t.updateWidth()})},e.prototype.updateTransitionStyle=function(){this._filterItems.forEach(function(t){return t.updateTransitionStyle()})},e.prototype.disableTransitions=function(){this._filterItems.forEach(function(t){return t.disableTransitions()})},e.prototype.enableTransitions=function(){return H(this,void 0,void 0,function(){var t=this;return W(this,function(e){return this._filterItems.forEach(function(e){return H(t,void 0,void 0,function(){return W(this,function(t){switch(t.label){case 0:return[4,e.enableTransitions()];case 1:return[2,t.sent()]}})})}),[2]})})},e.prototype.updateWidthWithTransitionsDisabled=function(){this.disableTransitions(),this.removeWidth(),this.updateWidth(),this.enableTransitions()},e}(M),G=function(){function t(t,e){this.filterItems=t,this.styledFilterItems=new q(t),this.options=e}return Object.defineProperty(t.prototype,"styles",{get:function(){return this.styledFilterItems},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"length",{get:function(){return this.filterItems.length},enumerable:!0,configurable:!0}),t.prototype.getItem=function(t){return this.filterItems[t]},t.prototype.destroy=function(){this.filterItems.forEach(function(t){return t.destroy()})},t.prototype.push=function(t){return this.filterItems.push(t)},t.prototype.remove=function(t){this.filterItems=this.filterItems.filter(function(e){return e.node!==t})},t.prototype.getFiltered=function(t){var e=this,n=this.options.searchTerm,r=this.search(this.filterItems,n);return"all"===t?r:r.filter(function(n){return e.shouldBeFiltered(n.getCategories(),t)})},t.prototype.getFilteredOut=function(t){var e=this,n=this.options.searchTerm;return this.filterItems.filter(function(r){var i=r.getCategories(),o=e.shouldBeFiltered(i,t),s=r.contentsMatchSearch(n);return!o||!s})},t.prototype.sort=function(t,e){void 0===t&&(t="index"),void 0===e&&(e="asc");var n,r,i=(n=this.filterItems,r=function(e){return e.getSortAttribute(t)},n.slice(0).sort(function(t){return function(e,n){var r=t(e),i=t(n);return r<i?-1:r>i?1:0}}(r))),o="asc"===e?i:i.reverse();this.filterItems=o},t.prototype.shuffle=function(){var t=this,e=this.getFiltered(this.options.filter);if(e.length>1){var n=this.getFiltered(this.options.filter).map(function(e){return t.filterItems.indexOf(e)}).slice(),r=void 0;do{r=d(e)}while(u(e,r));(r=d(e)).forEach(function(e,r){var i,o=n[r];t.filterItems=Object.assign([],t.filterItems,((i={})[o]=e,i))})}},t.prototype.search=function(t,e){return e?t.filter(function(t){return t.contentsMatchSearch(e)}):t},t.prototype.shouldBeFiltered=function(t,e){var n,r,i=this.options.getRaw().multifilterLogicalOperator;return Array.isArray(e)?"or"===i?!!(n=t,r=e,Array.prototype.filter.call(n,function(t){return r.includes(t)})).length:function(t,e){return t.reduce(function(t,n){return t&&e.includes(n)},!0)}(e,t):t.includes(e)},t}(),B=function(){return(B=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var i in e=arguments[n])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t}).apply(this,arguments)},Z=function(t){return{padding:t.get().gutterPixels+"px"}},$=function(){var t=function(e,n){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])})(e,n)};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}(),Q=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return $(e,t),e.prototype.initialize=function(){var t;this.set((t=this.options,B({},Z(t),{position:"relative",width:"100%",display:"flex",flexWrap:"wrap"})))},e.prototype.updatePaddings=function(){this.set(Z(this.options))},e.prototype.setHeight=function(t){this.set({height:t+"px"})},e}(A),V=function(){var t=function(e,n){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])})(e,n)};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}(),J=function(t){function e(e,n){var i=this;if(!e)throw new Error("Filterizr: could not initialize container, check the selector or node you passed to the constructor exists.");return(i=t.call(this,e,n)||this).styledNode=new Q(e,n),i._filterizrState=r.IDLE,i.styles.initialize(),i.filterItems=i.makeFilterItems(i.options),i.bindEvents(),i}return V(e,t),Object.defineProperty(e.prototype,"styles",{get:function(){return this.styledNode},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"filterizrState",{set:function(t){this._filterizrState=t},enumerable:!0,configurable:!0}),e.prototype.destroy=function(){t.prototype.destroy.call(this),this.unbindEvents(),this.filterItems.destroy()},e.prototype.makeFilterItems=function(t){var e=Array.from(this.node.querySelectorAll(t.get().gridItemsSelector)).map(function(e,n){return new N(e,n,t)}),n=new G(e,t);if(!n.length)throw new Error("Filterizr: cannot initialize empty container. Make sure the gridItemsSelector option corresponds to the selector of your grid's items");return n.styles.updateWidth(),n},e.prototype.insertItem=function(t){var e=t.cloneNode(!0);e.removeAttribute("style"),this.node.appendChild(e);var n=new N(e,this.filterItems.length,this.options);n.styles.enableTransitions(),n.styles.updateWidth(),this.filterItems.push(n)},e.prototype.removeItem=function(t){this.filterItems.remove(t),this.node.removeChild(t)},e.prototype.setHeight=function(t){this.dimensions.height=t,this.styles.setHeight(t)},e.prototype.bindEvents=function(){var t=this,e=this.options.get(),n=e.animationDuration,i=e.callbacks,o=e.delay,s=e.delayMode,u=e.gridItemsSelector,c="progressive"===s?o*this.filterItems.length:o;this.eventReceiver.on("transitionend",a(function(e){if(Array.from(e.target.classList).reduce(function(t,e){return t||u.includes(e)},!1)){switch(t._filterizrState){case r.FILTERING:t.trigger("filteringEnd");break;case r.SORTING:t.trigger("sortingEnd");break;case r.SHUFFLING:t.trigger("shufflingEnd")}t.filterizrState=r.IDLE}},100*n+c,!1)),this.eventReceiver.on("init",i.onInit),this.eventReceiver.on("filteringStart",i.onFilteringStart),this.eventReceiver.on("filteringEnd",i.onFilteringEnd),this.eventReceiver.on("shufflingStart",i.onShufflingStart),this.eventReceiver.on("shufflingEnd",i.onShufflingEnd),this.eventReceiver.on("sortingStart",i.onSortingStart),this.eventReceiver.on("sortingEnd",i.onSortingEnd)},e.prototype.unbindEvents=function(){this.eventReceiver.off("transitionend"),this.eventReceiver.off("init"),this.eventReceiver.off("filteringStart"),this.eventReceiver.off("filteringEnd"),this.eventReceiver.off("shufflingStart"),this.eventReceiver.off("shufflingEnd"),this.eventReceiver.off("sortingStart"),this.eventReceiver.off("sortingEnd")},e}(E);var U=function(){var t=function(e,n){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])})(e,n)};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}(),K=function(){return(K=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var i in e=arguments[n])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t}).apply(this,arguments)},X=function(t,e,n,r){return new(n||(n=Promise))(function(i,o){function s(t){try{u(r.next(t))}catch(t){o(t)}}function a(t){try{u(r.throw(t))}catch(t){o(t)}}function u(t){t.done?i(t.value):new n(function(e){e(t.value)}).then(s,a)}u((r=r.apply(t,e||[])).next())})},Y=function(t,e){var n,r,i,o,s={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(o){return function(a){return function(o){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,r&&(i=2&o[0]?r.return:o[0]?r.throw||((i=r.return)&&i.call(r),0):r.next)&&!(i=i.call(r,o[1])).done)return i;switch(r=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,r=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!(i=(i=s.trys).length>0&&i[i.length-1])&&(6===o[0]||2===o[0])){s=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){s.label=o[1];break}if(6===o[0]&&s.label<i[1]){s.label=i[1],i=o;break}if(i&&s.label<i[2]){s.label=i[2],s.ops.push(o);break}i[2]&&s.ops.pop(),s.trys.pop();continue}o=e.call(t,s)}catch(t){o=[6,t],r=0}finally{n=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,a])}}},tt=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return U(e,t),e.prototype.initialize=function(){var t=this.options.get().spinner.styles;this.set(K({},t,{opacity:1,transition:"all ease-out 500ms"}))},e.prototype.fadeOut=function(){return X(this,void 0,void 0,function(){return Y(this,function(t){switch(t.label){case 0:return[4,this.animate({opacity:0})];case 1:return t.sent(),[2]}})})},e}(A),et=function(t,e,n,r){return new(n||(n=Promise))(function(i,o){function s(t){try{u(r.next(t))}catch(t){o(t)}}function a(t){try{u(r.throw(t))}catch(t){o(t)}}function u(t){t.done?i(t.value):new n(function(e){e(t.value)}).then(s,a)}u((r=r.apply(t,e||[])).next())})},nt=function(t,e){var n,r,i,o,s={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(o){return function(a){return function(o){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,r&&(i=2&o[0]?r.return:o[0]?r.throw||((i=r.return)&&i.call(r),0):r.next)&&!(i=i.call(r,o[1])).done)return i;switch(r=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,r=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!(i=(i=s.trys).length>0&&i[i.length-1])&&(6===o[0]||2===o[0])){s=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){s.label=o[1];break}if(6===o[0]&&s.label<i[1]){s.label=i[1],i=o;break}if(i&&s.label<i[2]){s.label=i[2],s.ops.push(o);break}i[2]&&s.ops.pop(),s.trys.pop();continue}o=e.call(t,s)}catch(t){o=[6,t],r=0}finally{n=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,a])}}},rt=function(){function t(t,e){var n,r,i;this.filterContainer=t,this.node=(n=e.get().spinner,r='<?xml version="1.0" encoding="UTF-8"?><svg stroke="'+n.fillColor+'" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" stroke-width="2"><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="0s" calcMode="spline" dur="1.8s" keySplines="0.165, 0.84, 0.44, 1" keyTimes="0; 1" repeatCount="indefinite" values="1; 20"/><animate attributeName="stroke-opacity" begin="0s" calcMode="spline" dur="1.8s" keySplines="0.3, 0.61, 0.355, 1" keyTimes="0; 1" repeatCount="indefinite" values="1; 0"/></circle><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="-0.9s" calcMode="spline" dur="1.8s" keySplines="0.165, 0.84, 0.44, 1" keyTimes="0; 1" repeatCount="indefinite" values="1; 20"/><animate attributeName="stroke-opacity" begin="-0.9s" calcMode="spline" dur="1.8s" keySplines="0.3, 0.61, 0.355, 1" keyTimes="0; 1" repeatCount="indefinite" values="1; 0"/></circle></g></svg>',(i=document.createElement("img")).classList.add("Filterizr__spinner"),i.src="data:image/svg+xml;base64,"+window.btoa(r),i.alt="Spinner",i),this.styledNode=new tt(this.node,e),this.initialize()}return Object.defineProperty(t.prototype,"styles",{get:function(){return this.styledNode},enumerable:!0,configurable:!0}),t.prototype.destroy=function(){return et(this,void 0,void 0,function(){return nt(this,function(t){switch(t.label){case 0:return[4,this.styles.fadeOut()];case 1:return t.sent(),this.filterContainer.node.removeChild(this.node),[2]}})})},t.prototype.initialize=function(){this.styles.initialize(),this.filterContainer.node.appendChild(this.node)},t}(),it=n(1),ot=n.n(it);function st(t,e){return t.reduce(function(t,n){return t+n.width+e},0)}function at(t,e){return t.length?t.reduce(function(t,n){return t+n.height+e},0):0}var ut=function(){return(ut=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var i in e=arguments[n])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t}).apply(this,arguments)},ct=function(){function t(t){this.init(t)}return t.prototype.init=function(t){this.root={x:0,y:0,w:t}},t.prototype.fit=function(t){var e,n,r,i=t.length,o=i>0?t[0].h:0;for(this.root.h=o,e=0;e<i;e++)r=t[e],(n=this.findNode(this.root,r.w,r.h))?r.fit=this.splitNode(n,r.w,r.h):r.fit=this.growDown(r.w,r.h)},t.prototype.findNode=function(t,e,n){return t.used?this.findNode(t.right,e,n)||this.findNode(t.down,e,n):e<=t.w&&n<=t.h?t:null},t.prototype.splitNode=function(t,e,n){return t.used=!0,t.down={x:t.x,y:t.y+n,w:t.w,h:t.h-n},t.right={x:t.x+e,y:t.y,w:t.w-e,h:n},t},t.prototype.growDown=function(t,e){var n;return this.root={used:!0,x:0,y:0,w:this.root.w,h:this.root.h+e,down:{x:0,y:this.root.h,w:this.root.w,h:e},right:this.root},(n=this.findNode(this.root,t,e))?this.splitNode(n,t,e):null},t}(),lt=ot()(function(t,e,n){var r=n.gutterPixels,o=n.layout;if(!e.length)return{containerHeight:0,itemsPositions:[]};switch(o){case i.HORIZONTAL:return function(t,e){return{containerHeight:Math.max.apply(Math,t.map(function(t){return t.height}))+2*e,itemsPositions:t.map(function(n,r){return{left:st(t.slice(0,r),e),top:0}})}}(e,r);case i.VERTICAL:return function(t,e){return{containerHeight:at(t,e)+e,itemsPositions:t.map(function(n,r){return{left:0,top:at(t.slice(0,r),e)}})}}(e,r);case i.SAME_HEIGHT:return function(t,e,n){var r=e.map(function(t,r){var i=t.width;return e.slice(0,r).reduce(function(t,e){return t+e.width+2*n},0)+i+n}),i=r.reduce(function(e,n,r){var i,o=Object.keys(e).length;return ut({},e,n>t*o&&((i={})[o]=r,i))},{0:0}),o=e.map(function(o,s){var a=o.height,u=Math.floor(r[s]/t);return{left:e.slice(i[u],s).reduce(function(t,e){return t+e.width+n},0),top:(a+n)*u}});return{containerHeight:Object.keys(i).length*(e[0].height+n)+n,itemsPositions:o}}(t,e,r);case i.SAME_WIDTH:return function(t,e,n){var r=Math.floor(t/(e[0].width+n)),i=e.map(function(t,i){var o=t.width,s=Math.floor(i/r);return{left:(i-r*s)*(o+n),top:e.slice(0,i).filter(function(t,e){return(i-e)%r==0}).reduce(function(t,e){return t+e.height+n},0)}}),o=e.reduce(function(t,e,i){var o=e.height,s=Math.floor(i/r);return t[i-r*s]+=o+n,t},Array.apply(null,Array(r)).map(Number.prototype.valueOf,0));return{containerHeight:Math.max.apply(Math,o)+n,itemsPositions:i}}(t,e,r);case i.PACKED:return function(t,e,n){var r=new ct(t),i=e.map(function(t){var e=t.width,r=t.height;return{w:e+n,h:r+n}});r.fit(i);var o=i.map(function(t){var e=t.fit;return{left:e.x,top:e.y}});return{containerHeight:r.root.h+n,itemsPositions:o}}(t,e,r);case i.SAME_SIZE:default:return function(t,e,n){var r=Math.floor(t/(e[0].width+n)),i=e.map(function(t,e){var i=t.width,o=t.height,s=Math.floor(e/r);return{left:(e-r*s)*(i+n),top:s*(o+n)}});return{containerHeight:Math.ceil(e.length/r)*(e[0].height+n)+n,itemsPositions:i}}(t,e,r)}});function ft(t){if(!t)throw new Error("Filterizr as a jQuery plugin, requires jQuery to work. If you would prefer to use the vanilla JS version, please use the correct bundle file.");t.fn.filterizr=function(){var e="."+t.trim(this.get(0).className).replace(/\s+/g,"."),n=arguments;if(!this._fltr&&0===n.length||1===n.length&&"object"==typeof n[0]){var r=n.length>0?n[0]:v;this._fltr=new yt(e,r)}else if(n.length>=1&&"string"==typeof n[0]){var i=n[0],o=Array.prototype.slice.call(n,1),s=this._fltr;switch(i){case"filter":return s.filter.apply(s,o),this;case"insertItem":return s.insertItem.apply(s,o),this;case"removeItem":return s.removeItem.apply(s,o),this;case"toggleFilter":return s.toggleFilter.apply(s,o),this;case"sort":return s.sort.apply(s,o),this;case"shuffle":return s.shuffle.apply(s,o),this;case"search":return s.search.apply(s,o),this;case"setOptions":return s.setOptions.apply(s,o),this;case"destroy":return s.destroy.apply(s,o),delete this._fltr,this;default:throw new Error("Filterizr: "+i+" is not part of the Filterizr API. Please refer to the docs for more information.")}}return this}}var ht=function(t,e,n,r){return new(n||(n=Promise))(function(i,o){function s(t){try{u(r.next(t))}catch(t){o(t)}}function a(t){try{u(r.throw(t))}catch(t){o(t)}}function u(t){t.done?i(t.value):new n(function(e){e(t.value)}).then(s,a)}u((r=r.apply(t,e||[])).next())})},pt=function(t,e){var n,r,i,o,s={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(o){return function(a){return function(o){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,r&&(i=2&o[0]?r.return:o[0]?r.throw||((i=r.return)&&i.call(r),0):r.next)&&!(i=i.call(r,o[1])).done)return i;switch(r=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,r=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!(i=(i=s.trys).length>0&&i[i.length-1])&&(6===o[0]||2===o[0])){s=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){s.label=o[1];break}if(6===o[0]&&s.label<i[1]){s.label=i[1],i=o;break}if(i&&s.label<i[2]){s.label=i[2],s.ops.push(o);break}i[2]&&s.ops.pop(),s.trys.pop();continue}o=e.call(t,s)}catch(t){o=[6,t],r=0}finally{n=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,a])}}},dt=n(0),yt=function(){function t(t,e){void 0===t&&(t=".filtr-container"),void 0===e&&(e={}),this.options=new b(e);var n=this.options,r=n.areControlsEnabled,i=n.controlsSelector,o=n.isSpinnerEnabled;this.windowEventReceiver=new y(window),this.filterContainer=new J(c(t),this.options),this.imagesHaveLoaded=!this.filterContainer.node.querySelectorAll("img").length,r&&(this.filterControls=new w(this,i)),o&&(this.spinner=new rt(this.filterContainer,this.options)),this.initialize()}return Object.defineProperty(t.prototype,"filterItems",{get:function(){return this.filterContainer.filterItems},enumerable:!0,configurable:!0}),t.prototype.filter=function(t){var e=this.filterContainer;e.trigger("filteringStart"),e.filterizrState=r.FILTERING,t=Array.isArray(t)?t.map(function(t){return t.toString()}):t.toString(),this.options.filter=t,this.render()},t.prototype.destroy=function(){var t=this.windowEventReceiver,e=this.filterControls;this.filterContainer.destroy(),t.destroy(),this.options.areControlsEnabled&&e&&e.destroy()},t.prototype.insertItem=function(t){return ht(this,void 0,void 0,function(){return pt(this,function(e){switch(e.label){case 0:return this.filterContainer.insertItem(t),[4,this.waitForImagesToLoad()];case 1:return e.sent(),this.render(),[2]}})})},t.prototype.removeItem=function(t){this.filterContainer.removeItem(t),this.render()},t.prototype.sort=function(t,e){void 0===t&&(t="index"),void 0===e&&(e="asc");var n=this.filterContainer,i=this.filterItems;n.trigger("sortingStart"),n.filterizrState=r.SORTING,i.sort(t,e),this.render()},t.prototype.search=function(t){void 0===t&&(t=this.options.get().searchTerm),this.options.searchTerm=t.toLowerCase(),this.render()},t.prototype.shuffle=function(){var t=this.filterContainer,e=this.filterItems;t.trigger("shufflingStart"),t.filterizrState=r.SHUFFLING,e.shuffle(),this.render()},t.prototype.setOptions=function(t){var e=this.filterContainer,n=this.filterItems,r="animationDuration"in t||"delay"in t||"delayMode"in t;(t.callbacks||r)&&e.unbindEvents(),this.options.set(t),(t.easing||r)&&n.styles.updateTransitionStyle(),(t.callbacks||r)&&e.bindEvents(),"searchTerm"in t&&this.search(t.searchTerm),("filter"in t||"multifilterLomultifilterLogicalOperator"in t)&&this.filter(this.options.filter),"gutterPixels"in t&&(this.filterContainer.styles.updatePaddings(),this.filterItems.styles.updateWidthWithTransitionsDisabled(),this.render())},t.prototype.toggleFilter=function(t){this.options.toggleFilter(t),this.filter(this.options.filter)},t.prototype.render=function(){var t=this.filterContainer,e=this.filterItems,n=this.options,r=e.getFiltered(n.filter);e.styles.resetDisplay(),e.getFilteredOut(n.filter).forEach(function(t){t.filterOut()});var i=lt(t.dimensions.width,r.map(function(t){return t.dimensions}),this.options.get()),o=i.containerHeight,s=i.itemsPositions;t.setHeight(o),r.forEach(function(t,e){t.filterIn(s[e])})},t.prototype.initialize=function(){return ht(this,void 0,void 0,function(){var t,e,n,r;return pt(this,function(i){switch(i.label){case 0:return e=(t=this).filterContainer,n=t.filterItems,r=t.spinner,this.bindEvents(),[4,this.waitForImagesToLoad()];case 1:return i.sent(),this.options.isSpinnerEnabled?[4,r.destroy()]:[3,3];case 2:i.sent(),i.label=3;case 3:return this.render(),[4,n.styles.enableTransitions()];case 4:return i.sent(),e.trigger("init"),[2]}})})},t.prototype.bindEvents=function(){var t=this,e=this.filterItems;this.windowEventReceiver.on("resize",a(function(){e.styles.updateWidthWithTransitionsDisabled(),t.render()},50,!1))},t.prototype.waitForImagesToLoad=function(){return ht(this,void 0,void 0,function(){var t,e,n,r=this;return pt(this,function(i){return e=(t=this).imagesHaveLoaded,n=t.filterContainer,e?[2,Promise.resolve()]:[2,new Promise(function(t){dt(n.node,function(){r.imagesHaveLoaded=!0,t()})})]})})},t.FilterContainer=J,t.FilterItem=N,t.defaultOptions=v,t.installAsJQueryPlugin=ft,t}();n.d(e,"default",function(){return yt})}]).default});
},{}],3:[function(require,module,exports){
/*! js-cookie v3.0.5 | MIT */
;
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
    var current = global.Cookies;
    var exports = global.Cookies = factory();
    exports.noConflict = function () { global.Cookies = current; return exports; };
  })());
})(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      if (value[0] === '"') {
        value = value.slice(1, -1);
      }
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (name, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      name = encodeURIComponent(name)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie =
        name + '=' + converter.write(value, name) + stringifiedAttributes)
    }

    function get (name) {
      if (typeof document === 'undefined' || (arguments.length && !name)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        try {
          var found = decodeURIComponent(parts[0]);
          jar[found] = converter.read(value, found);

          if (name === found) {
            break
          }
        } catch (e) {}
      }

      return name ? jar[name] : jar
    }

    return Object.create(
      {
        set,
        get,
        remove: function (name, attributes) {
          set(
            name,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

}));

},{}],4:[function(require,module,exports){
"use strict";

require("./app/polyfills");

require("./app/init");

require("./app/inputs");

require("./app/partners-link-hover");

require("./app/menu-top");

require("./app/submenu");

require("./app/scroll");

require("./app/aside-scroll");

require("./app/accordion");

require("./app/mobile-menu");

require("./app/open-modals");

require("./app/contacts-tabs");

require("./app/glide");

require("./app/form");

require("./app/load-file");

require("./app/filter");

require("./app/socials-scroll");

require("./app/load-more");

require("./app/lazy-load");

require("./app/left-menu-height");

require("./app/cookies");

},{"./app/accordion":5,"./app/aside-scroll":7,"./app/contacts-tabs":8,"./app/cookies":9,"./app/filter":10,"./app/form":11,"./app/glide":12,"./app/init":14,"./app/inputs":15,"./app/lazy-load":16,"./app/left-menu-height":17,"./app/load-file":18,"./app/load-more":19,"./app/menu-top":20,"./app/mobile-menu":21,"./app/open-modals":23,"./app/partners-link-hover":24,"./app/polyfills":25,"./app/scroll":26,"./app/socials-scroll":27,"./app/submenu":28}],5:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var Accordion = /*#__PURE__*/function () {
  function Accordion(menu, isMultiple) {
    _classCallCheck(this, Accordion);

    if (menu) {
      this.menu = menu;
      this.isMultiple = isMultiple;
      this.init();
    }
  }

  _createClass(Accordion, [{
    key: "init",
    value: function init() {
      var _this = this;

      this.dropdownItems = this.menu.querySelectorAll('[data-toggle="expand"]');
      this.dropdownItems.forEach(function (item) {
        item.children[0].addEventListener('click', function (evt) {
          _this.dropdown(evt, _this.isMultiple);
        });
      });
    }
  }, {
    key: "dropdown",
    value: function dropdown(evt, isMultiple) {
      var dropdownLink = evt.target;
      var dropdownItem = dropdownLink.parentElement;
      var dropdownMenu = dropdownLink.nextElementSibling;

      if (!dropdownItem.classList.contains('active')) {
        dropdownItem.classList.add('active');
        dropdownMenu.removeAttribute('style');
        dropdownMenu.removeEventListener('transitionend', this.onMenuTransitionend);
        var height = dropdownMenu.offsetHeight;
        dropdownMenu.style.height = '0px';
        setTimeout(function () {
          dropdownMenu.style.height = height + 'px';
        }, 0);
      } else {
        dropdownItem.classList.remove('active');
        dropdownMenu.style.height = '0px';
        dropdownMenu.addEventListener('transitionend', this.onMenuTransitionend);
      }

      if (!isMultiple) {
        var activeElements = dropdownItem.parentElement.querySelectorAll('[data-toggle="expand"].active');
        activeElements.forEach(function (item) {
          if (item !== dropdownItem) {
            item.classList.remove('active');
          }
        });
      }
    }
  }, {
    key: "onMenuTransitionend",
    value: function onMenuTransitionend(evt) {
      evt.target.parentElement.classList.remove('active');
    }
  }]);

  return Accordion;
}();

var expandMenu = document.querySelector('[data-type="expand-menu"]');

if (expandMenu) {
  new Accordion(expandMenu, false);
}

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var AjaxHandler = /*#__PURE__*/function () {
  function AjaxHandler(options) {
    _classCallCheck(this, AjaxHandler);

    this.options = options;
    this.form = this.options.form;
    this.loader = this.form ? this.form.querySelector('.loader') : null;
    this.btn = this.form ? this.form.querySelector('button[type="submit"]') : null;
  }

  _createClass(AjaxHandler, [{
    key: "onResponseSuccess",
    value: function onResponseSuccess(callback) {
      if (callback) {
        callback();
      }
    }
  }, {
    key: "onResponseFalse",
    value: function onResponseFalse(callback) {
      if (callback) {
        callback();
      }
    }
  }, {
    key: "onAjaxHandlerProcess",
    value: function onAjaxHandlerProcess(callback) {
      if (callback) {
        callback();
      }
    }
  }, {
    key: "send",
    value: function send(data, callbackSuccess, callbackFalse) {
      var _this = this;

      // Event to modify data before ajax sending
      var beforeSubmitEvent;

      if (this.form) {
        beforeSubmitEvent = new CustomEvent('ajax:beforeSubmit', {
          'detail': {
            formData: data
          }
        });
        this.form.dispatchEvent(beforeSubmitEvent);
      }

      var xhr = new XMLHttpRequest();
      xhr.open('POST', this.options.url, true);
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.send(beforeSubmitEvent ? beforeSubmitEvent.detail.formData : data);

      this._disableBtn();

      this._showLoader();

      xhr.onreadystatechange = function () {
        if (xhr.readyState === xhr.DONE && xhr.status === 200) {
          setTimeout(function () {
            _this._enableBtn();

            _this._hideLoader();

            var response = JSON.parse(xhr.responseText);
            _this.response = response;

            if (response.status === 'error') {
              _this.onResponseFalse(callbackFalse);
            } else {
              _this.onResponseSuccess(callbackSuccess);
            }
          }, 1000);
        }
      };
    }
  }, {
    key: "_disableBtn",
    value: function _disableBtn() {
      if (this.btn) {
        this.btn.setAttribute('disabled', 'disabled');
        this.btn.classList.add('btn--loading');
      }
    }
  }, {
    key: "_enableBtn",
    value: function _enableBtn() {
      if (this.btn) {
        this.btn.removeAttribute('disabled');
        this.btn.classList.remove('btn--loading');
      }
    }
  }, {
    key: "_hideLoader",
    value: function _hideLoader() {
      if (this.loader) {
        this.loader.style.display = 'none';
      }
    }
  }, {
    key: "_showLoader",
    value: function _showLoader() {
      if (this.loader) {
        this.loader.style.display = 'block';
      }
    }
  }]);

  return AjaxHandler;
}();

var _default = AjaxHandler;
exports["default"] = _default;

},{}],7:[function(require,module,exports){
"use strict";

var aside = document.querySelector('.layout__aside');
var asideMenu = document.querySelector('[data-toggle="aside-scroll"]');
var bgSection = document.querySelectorAll('.page-section--bg');
var asideMenuHidingElement = document.querySelector('[data-toggle="aside-nav-hide"]');

var asideMenuInit = function asideMenuInit() {
  // determine the hide height of the menu if there is a block for the entire width of the container
  var hidingHeight = asideMenuHidingElement ? asideMenuHidingElement.offsetTop : null; // array of upper and lower borders of blocks with background

  var breakpoints = [];
  bgSection.forEach(function (section) {
    breakpoints.push([section.offsetTop, section.offsetTop + section.offsetHeight]);
  });
  var headerHeight = document.querySelector('.header').clientHeight;
  var asideMenuTop = aside.offsetTop;
  var asideMenuHeight = asideMenu.offsetHeight;
  var isHiding = false;
  window.addEventListener('scroll', function () {
    var scroll = window.scrollY || window.pageYOffset;

    if (scroll >= asideMenuTop - headerHeight) {
      asideMenu.classList.add('scroll');
    } else {
      asideMenu.classList.remove('scroll');
    }

    breakpoints.forEach(function (it) {
      // show the menu and change the font color on the block with the background
      if (scroll > it[0] && scroll + asideMenuHeight + headerHeight < it[1]) {
        setTimeout(function () {
          asideMenu.classList.remove('hidden');
          asideMenu.classList.add('second');
        }, 0);
      } else {
        asideMenu.classList.remove('second');
      } // hide the menu 100px before the beginning and end of the block with the background


      if (scroll + asideMenuHeight + headerHeight > it[0] && scroll < it[0] || scroll + asideMenuHeight + headerHeight > it[1] && scroll < it[1]) {
        setTimeout(function () {
          asideMenu.classList.add('hidden');
        }, 0);
      } else {
        setTimeout(function () {
          asideMenu.classList.remove('hidden');
        }, 0);
      }
    }); // show/hide the menu if there is a block without a menu

    if (hidingHeight && scroll + asideMenuHeight + headerHeight > hidingHeight) {
      setTimeout(function () {
        asideMenu.classList.add('hidden');
        isHiding = true;
      }, 0);
    } else {
      if (isHiding) {
        asideMenu.classList.remove('hidden');
        isHiding = false;
      }
    }
  });
};

if (asideMenu) {
  asideMenuInit();
  window.addEventListener('resize', asideMenuInit);
}

},{}],8:[function(require,module,exports){
"use strict";

var buttonsTabs = document.querySelectorAll('[data-toggle="tabs"]');

if (buttonsTabs.length) {
  var currentBtn = buttonsTabs[0],
      currentTab = document.querySelector('#' + currentBtn.getAttribute('data-target'));
  buttonsTabs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-target');
      var tab = document.querySelector('#' + target);

      if (currentBtn) {
        currentBtn.classList.remove('active');
        currentTab.classList.remove('active');
      }

      btn.classList.add('active');
      tab.classList.add('active');
      currentTab = tab;
      currentBtn = btn;
    });
  });
}

},{}],9:[function(require,module,exports){
"use strict";

var _jsCookie = _interopRequireDefault(require("js-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

document.addEventListener('DOMContentLoaded', function () {
  var cookies = document.querySelector('#cookiesMessage');

  if (cookies) {
    cookies.querySelector('[data-toggle="cookies-accept"]').addEventListener('click', function () {
      cookies.classList.add('hide');

      _jsCookie["default"].set('anten_cookies', 'accepted', {
        expires: 365
      });

      setTimeout(function () {
        cookies.remove();
      }, 300);
    });
    cookies.querySelector('[data-toggle="cookies-reject"]').addEventListener('click', function () {
      _jsCookie["default"].set('anten_cookies', 'rejected', {
        expires: 365
      });

      setTimeout(function () {
        window.location.reload();
      }, 300);
    });
  }
});

},{"js-cookie":3}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterOptions = exports.filter = void 0;

var _filterizr = _interopRequireDefault(require("filterizr"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var filterContainer = document.querySelector('.filter-container');
var filter = null;
exports.filter = filter;
var filterOptions = {};
exports.filterOptions = filterOptions;

if (filterContainer) {
  var filterButtons = document.querySelectorAll('.filter-head [data-filter]');
  var attributes = filterContainer.attributes;
  var attributeNamePart = 'data-f-';

  for (var i = attributes.length - 1; i >= 0; i--) {
    if (attributes[i].name.indexOf(attributeNamePart) !== -1) {
      filterOptions[attributes[i].name.replace(attributeNamePart, '')] = attributes[i].value;
    }
  }

  exports.filter = filter = new _filterizr["default"](filterContainer, filterOptions);
  filterButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      filterButtons.forEach(function (btn) {
        return btn.classList.remove('active');
      });
      btn.classList.add('active');
    });
  });
}

},{"filterizr":2}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formsToDef = formsToDef;

var _ajaxHandler = _interopRequireDefault(require("./ajax-handler"));

var _modal = _interopRequireDefault(require("./modal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var forms = document.querySelectorAll('.form') || [];
forms.forEach(function (item) {
  var checkboxPrivacy = item.querySelector('[name="privacy"]');
  var checkboxAgreement = item.querySelector('[name="agreement"]');
  var button = item.querySelector('[type="submit"]');

  if (checkboxPrivacy && checkboxAgreement && button) {
    var updateButtonState = function updateButtonState() {
      button.disabled = !(checkboxPrivacy.checked && checkboxAgreement.checked);
    };

    checkboxPrivacy.addEventListener('change', updateButtonState);
    checkboxAgreement.addEventListener('change', updateButtonState);
  }

  item.addEventListener('submit', function (e) {
    e.preventDefault();
    var warranty = document.getElementById('warranty');
    var unitTable = document.getElementById('unit');
    var notFound = document.getElementById('notFound');
    var btnClaim = document.getElementById('btnClaim');
    var warrantyItems;

    if (warranty) {
      warrantyItems = warranty.querySelectorAll('.warranty__item');
      warranty.classList.remove('warranty--visible');

      if (warrantyItems.length) {
        warrantyItems.forEach(function (item) {
          return item.querySelector('.warranty__value').innerHTML = '';
        });
      }
    }

    if (unitTable) {
      var unitRows = unitTable.querySelectorAll('.warranty__item');
      unitTable.classList.remove('warranty--visible');

      if (unitRows.length) {
        unitRows.forEach(function (item) {
          return item.remove();
        });
      }
    }

    if (notFound) {
      notFound.classList.remove('warranty--visible');
    }

    if (btnClaim) {
      btnClaim.classList.remove('warranty--visible');
    }

    var form = e.target;
    var url = form.getAttribute('action');
    var fileInput = form.querySelector('input[type="file"]');
    var data = new FormData(form);

    if (fileInput) {
      for (var i = 0; i < fileInput.files.length; i++) {
        var file = fileInput.files[i];
        data.append('files[]', file);
      }
    }

    var ajaxHandler = new _ajaxHandler["default"]({
      'url': url,
      'form': form
    });
    ajaxHandler.send(data, function () {
      var response = ajaxHandler.response;
      var currentModal = form.closest('.popup');

      if (response['counters']) {
        if (response['counters']['ym_counter']) {
          ym(response['counters']['ym_counter'], 'reachGoal', response['counters']['goals']['ym']);
        }

        if (response['counters']['ga_counter']) {
          ga('send', 'event', response['counters']['goals']['ga']['category'], response['counters']['goals']['ga']['action'], response['counters']['goals']['ga']['label']);
        }
      }

      if (response.redirect) {
        window.location.replace(response.redirect);
      } else if (response.result && warranty && warrantyItems.length) {
        var popupClaim = document.getElementById('popup-claim');
        warranty.classList.add('warranty--visible');
        btnClaim.classList.add('warranty--visible');
        warrantyItems.forEach(function (item) {
          item.querySelector('.warranty__value').innerHTML = response.result[item.dataset.attr];

          if (popupClaim) {
            var input = popupClaim.querySelector("[name=\"".concat(item.dataset.attr, "\"]"));

            if (input) {
              input.value = response.result[item.dataset.attr];
              input.closest('.input-wrapper').classList.add('filled');
            }
          }
        });

        if (response.result.unit && Array.isArray(response.result.unit)) {
          var unit = response.result.unit;

          if (unitTable) {
            unitTable.classList.add('warranty--visible');
            unit.forEach(function (row) {
              var rowDiv = document.createElement('div');
              rowDiv.classList.add('warranty__item');
              row.forEach(function (cell, index) {
                var cellDiv = document.createElement('div');
                cellDiv.classList.add('warranty__cell');

                if (index === 3) {
                  cell = cell.join('<br>');
                }

                cellDiv.innerHTML = cell;
                rowDiv.appendChild(cellDiv);
              });
              unitTable.appendChild(rowDiv);
            });
          }
        }
      } else if (currentModal) {
        currentModal.querySelector('.popup__content').style.display = 'none';
        currentModal.querySelector('.response-msg').innerHTML = response.message;
      } else {
        document.querySelector('#popup-success .popup__content').innerHTML = response.message;

        _modal["default"].open('popup-success');

        formsToDef(form);
      }
    }, function () {
      var response = ajaxHandler.response;
      onResponseFalse(form, response);
    });
  });
});

function onResponseFalse(form, response) {
  var inputs = form.querySelectorAll('.form-control');
  inputs.forEach(function (input) {
    var errorMsg = input.parentElement.querySelector('.error-msg');
    var inputWrap = input.parentElement;

    for (var error in response.errors) {
      if (input.name === response.errors[error].field && !errorMsg) {
        inputWrap.classList.add('error');
        input.insertAdjacentHTML('afterend', '<span class="error-msg">' + response.errors[error].message + '</span>');
      }

      if (response.errors[error].field === 'serialNumber') {
        var notFound = document.getElementById('notFound');

        if (notFound) {
          notFound.classList.add('warranty--visible');
        }
      }
    }
  });
}

function formsToDef(form, modal) {
  if (form) {
    form.classList.remove('hidden');
    var inputs = form.querySelectorAll('.form-control');
    inputs.forEach(function (input) {
      if (input.parentElement.classList.contains('error')) {
        input.parentElement.classList.remove('error');
      }

      var errorMsg = input.parentElement.querySelector('.error-msg');

      if (errorMsg) {
        input.parentElement.removeChild(errorMsg);
      }
    });
  }

  if (modal) {
    var formResponse = modal.querySelector('.response-msg');
    modal.querySelector('.popup__content').style.display = null;

    if (formResponse) {
      formResponse.innerHTML = '';
    }
  }
}

},{"./ajax-handler":6,"./modal":22}],12:[function(require,module,exports){
"use strict";

var _glide = _interopRequireDefault(require("../vendor/glide.min"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var sliders = document.querySelectorAll('.glide') || [];
var stateBreakpoint = 1400;
var isDestroyed = true;
var glides = [];
/*
// TODO: dynamically change dots on resize
const customLength = function (Glide, Components, Events) {
  return {
    mount() {
      const dotsContainer = Glide.selector.querySelector('.glide__bullets');
      //const slideNumbers = Math.ceil(Components.Sizes.length / Glide.settings.perView);

      while (dotsContainer.firstChild) {
        dotsContainer.removeChild(dotsContainer.firstChild);
      }

      let bullets = [];

      for (let i = 0; i < Components.Sizes.length; i++) {
        const bullet = document.createElement('button');
        bullet.classList.add('glide__bullet', 'dots-glide__btn');
        bullet.setAttribute('data-glide-dir', '=' + i);

        const dot = document.createElement('span');
        dot.classList.add('dots-glide__dot', 'dots-glide__dot2');

        if (i % Glide.settings.perView !== 0) {
          bullet.style.display = 'none';
        }

        bullet.append(dot);
        bullets.push(bullet);
      }

      bullets.forEach((bullet) => {
        dotsContainer.append(bullet);
      });
    }
  };
};
*/

var addsGlide = function addsGlide() {
  sliders.forEach(function (slider) {
    var breakpoints = {
      576: {
        perView: 1,
        focusAt: 'center'
      },
      992: {
        perView: 2,
        focusAt: 1
      }
    };
    var glide = new _glide["default"](slider, {
      type: 'carousel',
      startAt: 0,
      perView: 3,
      gap: 30,
      focusAt: 1,
      breakpoints: breakpoints
    });
    glides.push(glide);
    var bulletCount = slider.querySelectorAll('.glide__slide').length;
    var bulletWrapper = slider.querySelector('.glide__bullets');

    var addsBullets = function addsBullets() {
      for (var i = 0; i < bulletCount; i++) {
        var bullet = document.createElement('button');
        bullet.classList.add('glide__bullet', 'dots-glide__btn');
        bullet.setAttribute('data-glide-dir', '=' + i);
        var dot = document.createElement('span');
        dot.classList.add('dots-glide__dot');
        var allBreakpoints = Object.keys(breakpoints);
        var currentPerView = 3;

        for (var j = 0; j < allBreakpoints.length; j++) {
          if (window.innerWidth < allBreakpoints[j]) {
            currentPerView = breakpoints[allBreakpoints[j]].perView;
            break;
          }
        }

        if (i % currentPerView !== 0) {
          bullet.style.display = 'none';
        }

        bullet.append(dot);
        bulletWrapper.appendChild(bullet);
      }
    };
    /* TODO: change active dots on resize
    let activeBullet = 0;
    glide.on('run.after', function() {
      activeBullet = Number(slider.querySelector('.glide__bullet--active').getAttribute('data-glide-dir').replace(/[^\d]/g, ''));
    });
    */


    var removeBullets = function removeBullets() {
      while (bulletWrapper.firstChild) {
        bulletWrapper.removeChild(bulletWrapper.firstChild);
      }
    };

    glide.on('resize', function () {
      removeBullets();
      addsBullets();
    });
    removeBullets();
    addsBullets();
    glide.mount();
  });
  isDestroyed = false;
};

var glidesHandler = function glidesHandler() {
  if (window.innerWidth < stateBreakpoint && isDestroyed) {
    addsGlide();
  } else if (window.innerWidth > stateBreakpoint && !isDestroyed) {
    glides.forEach(function (glide) {
      glide.destroy();
      isDestroyed = true;
    });
    glides = [];
  }
};

window.addEventListener('resize', glidesHandler);
glidesHandler();

},{"../vendor/glide.min":30}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMobileDevice = void 0;

var isMobileDevice = function isMobileDevice() {
  return typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
};

exports.isMobileDevice = isMobileDevice;

},{}],14:[function(require,module,exports){
"use strict";

if (navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
  document.body.classList.add('ios-browser');
}

},{}],15:[function(require,module,exports){
"use strict";

var inputs = document.querySelectorAll('.input-wrapper input, .input-wrapper .input');

var inputFocus = function inputFocus(e) {
  var input = e.target;
  var inputControl = input.parentElement;
  inputControl.classList.add('focused');
};

var inputBlur = function inputBlur(e) {
  var input = e.target;
  var inputControl = input.parentElement;
  inputControl.classList.remove('focused');

  if (input.value !== '') {
    inputControl.classList.add('filled');
    inputControl.classList.remove('error');
  } else {
    inputControl.classList.remove('filled');
  }
};

var inputTyping = function inputTyping(e) {
  var input = e.target;
  var inputControl = input.parentElement;
  var errorMsg = inputControl.querySelector('.error-msg');
  inputControl.classList.remove('error');

  if (errorMsg) {
    errorMsg.remove();
  }
};

if (inputs.length) {
  inputs.forEach(function (item) {
    item.addEventListener('focus', inputFocus);
  });
  inputs.forEach(function (item) {
    item.addEventListener('blur', inputBlur);
  });
  inputs.forEach(function (item) {
    item.addEventListener('input', inputTyping);
  });
}

},{}],16:[function(require,module,exports){
"use strict";

var lazyVideos = [].slice.call(document.querySelectorAll('video.custom-lazy'));

var lazyload = function lazyload() {
  if (window.innerWidth >= 992) {
    lazyVideos.forEach(function (video) {
      setVideosAttribute(video);
    });
  }
};

window.addEventListener('resize', lazyload);
lazyload();

function setVideosAttribute(lazyVideo) {
  var videoSources = lazyVideo.querySelectorAll('source');

  if (videoSources.length) {
    videoSources.forEach(function (source) {
      source.setAttribute('src', source.dataset.src);
    });
  } else {
    lazyVideo.setAttribute('src', lazyVideo.dataset.src);
  }

  lazyVideo.load();
  lazyVideo.classList.remove('custom-lazy');
  window.removeEventListener('resize', lazyload);
}

},{}],17:[function(require,module,exports){
"use strict";

var leftMenu = document.querySelector('[data-type="expand-menu"]');

if (leftMenu) {
  // const height = window.innerHeight - (window.pageYOffset + category.getBoundingClientRect().top) - 30;
  var top = parseInt(window.getComputedStyle(leftMenu, null).getPropertyValue('top'), 10);
  var height = window.innerHeight - top - 30;

  if (leftMenu.offsetHeight > height) {
    leftMenu.style.maxHeight = height + 'px';
  }
}

},{}],18:[function(require,module,exports){
"use strict";

var fileBlock = document.querySelector('[data-toggle="load-file"]');
var fileLabel, fileInput, fileInfo, resetBtn;

function handleFiles() {
  var fileList = this.files;
  fileLabel.classList.add('hide');
  var fileName = fileList[0].name;
  var fileSize = fileList[0].size;
  fileInfo.querySelector('[data-toggle="filename"]').textContent = fileName;
  fileInfo.querySelector('[data-toggle="file-size"]').textContent = fileSize + ' Kb';
  fileInfo.classList.add('show');
  resetBtn.addEventListener('click', function (evt) {
    evt.preventDefault();
    fileInput.value = '';
    fileInfo.classList.remove('show');
    fileLabel.classList.remove('hide');
  });
}

if (fileBlock) {
  fileLabel = fileBlock.querySelector('label');
  fileInput = fileBlock.querySelector('input[type="file"]');
  fileInfo = fileBlock.querySelector('[data-toggle="load-file-info"]');
  resetBtn = fileBlock.querySelector('[data-toggle="reset-file"]');
  fileInput.addEventListener('change', handleFiles, false);
}

},{}],19:[function(require,module,exports){
"use strict";

var _loadMore = _interopRequireDefault(require("../modules/load-more"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var loadMoreBtns = document.querySelectorAll('.loadmore-btn');
loadMoreBtns.forEach(function (btn) {
  return new _loadMore["default"](btn);
});

},{"../modules/load-more":29}],20:[function(require,module,exports){
"use strict";

var _submenu = require("./submenu");

var overlayBlock = document.querySelector('.overlay');
var header = document.querySelector('.header');
var menuItems = document.querySelectorAll('[data-toggle="open-menu"]');
var searchOpenBtn = document.querySelector('[data-toggle="open-search"]');
var searchBlock = document.querySelector('.search');

var closeHeader = function closeHeader() {
  if (!document.body.classList.contains('scrolled')) {
    header.classList.remove('header--active');
  }
};

menuItems.forEach(function (menuItem) {
  var currentMenu = menuItem.closest('.menu__item');
  var closeBtn = currentMenu.querySelector('[data-toggle="close-menu"]');
  menuItem.addEventListener('mouseover', function () {
    if (searchBlock.classList.contains('open')) {
      searchBlock.classList.remove('open');
      overlayBlock.classList.remove('overlay--visible');
    }

    overlayBlock.classList.add('overlay--visible');
    currentMenu.classList.add('open');
    header.classList.add('header--active');
    header.addEventListener('mouseleave', closeHeader);
  });
  closeBtn.addEventListener('click', function () {
    currentMenu.classList.remove('open');
    overlayBlock.classList.remove('overlay--visible');
    (0, _submenu.resetSubmenu)();
    closeHeader();
  });
  menuItem.closest('.menu__item').addEventListener('mouseleave', function () {
    currentMenu.classList.remove('open');
    overlayBlock.classList.remove('overlay--visible');
    (0, _submenu.resetSubmenu)();
  });
});

var closeSearch = function closeSearch() {
  searchBlock.classList.remove('open');
  overlayBlock.classList.remove('overlay--visible');
};

searchOpenBtn.addEventListener('click', function () {
  var searchCloseBtn = searchBlock.querySelector('[data-toggle="close-menu"]');

  if (!header.classList.contains('header--active')) {
    header.classList.add('header--active');
  }

  overlayBlock.classList.add('overlay--visible');
  searchBlock.classList.add('open');
  header.removeEventListener('mouseleave', closeHeader);
  searchCloseBtn.addEventListener('click', function () {
    closeSearch();
    closeHeader();
  });
  document.addEventListener('keydown', function (evt) {
    if (evt.code === 'Escape') {
      closeSearch();
      closeHeader();
    }
  });
  overlayBlock.addEventListener('click', function () {
    closeSearch();
    closeHeader();
  });
});

},{"./submenu":28}],21:[function(require,module,exports){
"use strict";

var _globalFunctions = require("./global-functions");

var _bodyScrollLock = require("body-scroll-lock");

var mobileMenuBtn = document.querySelector('[data-toggle="open-mobile-menu"]');
var header = document.querySelector('.header');
var body = document.body;
var overlayBlock = document.querySelector('.overlay');
var openMenuLinks = document.querySelectorAll('[data-toggle="open-mobile-menu"]:not([data-target="mobile-menu"])');
var searchMobileToggleBtns = document.querySelectorAll('[data-toggle="search-mobile"]');
var searchMobileBlock = document.querySelector('#search-mobile');
var currentMenu, currentLink, currentMenuList;
openMenuLinks.forEach(function (link) {
  link.addEventListener('click', function (evt) {
    var currentMenuItem = evt.target;
    var parent = currentMenuItem.parentElement;
    (0, _bodyScrollLock.clearAllBodyScrollLocks)();
    parent.classList.toggle('active');

    if (parent.classList.contains('active')) {
      (0, _bodyScrollLock.disableBodyScroll)(parent.querySelector('.mobile-menu__submenu'));
    } else if (parent.closest('.mobile-menu__submenu')) {
      (0, _bodyScrollLock.disableBodyScroll)(parent.closest('.mobile-menu__submenu'));
    } else {
      (0, _bodyScrollLock.disableBodyScroll)(currentMenuList);
    }
  });
});
searchMobileToggleBtns.forEach(function (btn) {
  btn.addEventListener('click', function () {
    searchMobileBlock.classList.toggle('open');
    searchMobileToggleBtns[0].classList.toggle('hidden');
  });
});

var openMenu = function openMenu(evt) {
  currentLink = evt.currentTarget;
  var id = currentLink.getAttribute('data-target');
  currentMenu = document.querySelector("#".concat(id));
  currentMenuList = currentMenu.querySelector('.mobile-menu__list');
  var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  var closeBtn = currentMenu.querySelector('[data-toggle="close-menu"]');
  setTimeout(function () {
    if (!(0, _globalFunctions.isMobileDevice)()) {
      body.style.paddingRight = scrollbarWidth + 'px';
      header.style.paddingRight = scrollbarWidth + 'px';
    }

    overlayBlock.classList.add('overlay--visible');
    currentMenu.classList.add('open');
    (0, _bodyScrollLock.disableBodyScroll)(currentMenuList);
  }, 0);
  closeBtn.addEventListener('click', closeMenu);
  overlayBlock.addEventListener('click', function () {
    closeMenu();
  });
  document.addEventListener('keydown', function (evt) {
    if (evt.code === 'Escape') {
      closeMenu();
    }
  });
};

var closeMenu = function closeMenu() {
  var activeMenus = document.querySelectorAll('.mobile-menu__item.active');
  var activeSearch = document.querySelector('.mobile-menu__search.open');

  if (currentMenu) {
    currentMenu.classList.add('out');
    overlayBlock.classList.remove('overlay--visible');
    setTimeout(function () {
      currentMenu.classList.remove('out');
      currentMenu.classList.remove('open');

      if (!(0, _globalFunctions.isMobileDevice)()) {
        body.style.paddingRight = '0';
        header.style.paddingRight = '0';
      }

      (0, _bodyScrollLock.clearAllBodyScrollLocks)();
    }, 300);
  }

  activeMenus.forEach(function (menu) {
    menu.classList.remove('active');
  });

  if (activeSearch) {
    activeSearch.classList.remove('open');
    searchMobileToggleBtns[0].classList.toggle('hidden');
  }
};

mobileMenuBtn.addEventListener('click', openMenu);

},{"./global-functions":13,"body-scroll-lock":1}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _globalFunctions = require("./global-functions");

var _bodyScrollLock = require("body-scroll-lock");

var _form = require("./form");

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var Modal = /*#__PURE__*/function () {
  function Modal(btn) {
    var _this = this;

    _classCallCheck(this, Modal);

    if (btn) {
      this.btn = btn;
      this.modalId = btn.getAttribute('data-target').replace('#', '');
      this.modal = document.getElementById(this.modalId);
      this.modalTitle = this.modal.querySelector('.popup__content h2');
      this.modalDescription = this.modal.querySelector('.popup__content h2 + p');
      this.form = this.modal.querySelector('form');
      this.btn.addEventListener('click', function () {
        _this._openModal();
      });

      this._init();
    }

    this.constructor.instance = null;
  }

  _createClass(Modal, [{
    key: "_init",
    value: function _init() {
      this.closeBtns = this.modal.querySelectorAll('[data-toggle="close"]');

      this._setCloseEventListeners();

      this.initialazed = true;
    }
  }, {
    key: "_setCloseEventListeners",
    value: function _setCloseEventListeners() {
      var _this2 = this;

      document.addEventListener('keydown', this._setCloseByKeysEventListener.bind(this));
      this.closeBtns.forEach(function (btn) {
        return btn.addEventListener('click', function () {
          return _this2._closeModal();
        });
      });
    }
  }, {
    key: "_setCloseByKeysEventListener",
    value: function _setCloseByKeysEventListener(e) {
      var key = e.key;

      if (key === 'Escape') {
        this._closeModal();

        document.removeEventListener('keydown', this._setCloseByKeysEventListener);
      }
    }
  }, {
    key: "_openModal",
    value: function _openModal(modalId) {
      var _this3 = this;

      var modal = modalId ? document.getElementById(modalId) : this.modal;
      this.modal = modal;
      document.body.classList.add('open-modal');
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      if (_bodyScrollLock.disableBodyScroll) {
        (0, _bodyScrollLock.disableBodyScroll)(this.modal);
      }

      if (this.btn && this.btn.dataset.model) {
        var title = this.btn.dataset.modalTitle;

        if (title && this.modalTitle) {
          this.modalTitle.dataset.defTitle = this.modalTitle.textContent;
          this.modalTitle.textContent = title;
        }

        if (this.modalDescription) {
          this.modalDescription.dataset.defDescription = this.modalDescription.textContent;
          this.modalDescription.textContent = this.btn.dataset.model;
        }

        if (this.form) {
          this.form.insertAdjacentHTML('beforeend', "<input type=\"hidden\" data-name=\"model\" name=\"model\" value=\"".concat(this.btn.dataset.model, "\">"));
        }
      }

      setTimeout(function () {
        if (_globalFunctions.isMobileDevice && !(0, _globalFunctions.isMobileDevice)()) {
          var rightOffset = scrollbarWidth + 'px';
          var header = document.querySelector('.header');
          var headerStyles = window.getComputedStyle(header);
          document.body.style.paddingRight = rightOffset;

          if (headerStyles.position === 'fixed' || headerStyles.position === 'absolute') {
            header.style.paddingRight = rightOffset;
          }
        }

        modal.classList.add('visible');
      }, 0);
      setTimeout(function () {
        document.addEventListener('click', _this3._closePopupByOuterClick.bind(_this3));
      }, 200);

      if (!this.initialazed) {
        this._init();
      }
    }
  }, {
    key: "_closeModal",
    value: function _closeModal(modal) {
      var _this4 = this;

      var header = document.querySelector('.header');

      if (modal && _typeof(modal) === 'object') {
        this.modal = modal;
      } else if (modal) {
        this.modal = document.getElementById(modal);
      }

      this.modal.classList.add('out');
      setTimeout(function () {
        _this4.modal.classList.remove('out');

        document.body.classList.remove('open-modal');

        _this4.modal.classList.remove('visible');

        if (_this4.modalTitle && _this4.modalTitle.dataset.defTitle) {
          _this4.modalTitle.textContent = _this4.modalTitle.dataset.defTitle;
          _this4.modalTitle.dataset.defTitle = '';
        }

        if (_this4.modalDescription && _this4.modalDescription.dataset.defDescription) {
          _this4.modalDescription.textContent = _this4.modalDescription.dataset.defDescription;
          _this4.modalDescription.dataset.defDescription = '';
        }

        if (_this4.form) {
          var modelField = _this4.form.querySelector('input[type="hidden"][data-name="model"]');

          if (modelField) {
            modelField.remove();
          }
        }

        (0, _bodyScrollLock.clearAllBodyScrollLocks)();
        document.body.style.paddingRight = null;

        if (header) {
          header.style.paddingRight = null;
        }
      }, 300);
      var form = this.modal.querySelector('.form');

      if (form) {
        (0, _form.formsToDef)(form, this.modal);
      }

      document.removeEventListener('click', this._closePopupByOuterClick);
    }
  }, {
    key: "_closePopupByOuterClick",
    value: function _closePopupByOuterClick(e) {
      var target = e.target;

      if (!target.closest('.popup') && !(e.target.getAttribute('data-toggle') === 'modal')) {
        this._closeModal();
      }
    }
  }], [{
    key: "open",
    value: function open(modalId) {
      this._setInstance();

      this.prototype.instance._openModal(modalId);
    }
  }, {
    key: "close",
    value: function close(modalId) {
      this._setInstance();

      this.prototype.instance._closeModal(modalId);
    }
  }, {
    key: "_setInstance",
    value: function _setInstance() {
      this.prototype.instance = new Modal();
    }
  }]);

  return Modal;
}();

var _default = Modal;
exports["default"] = _default;

},{"./form":11,"./global-functions":13,"body-scroll-lock":1}],23:[function(require,module,exports){
"use strict";

var _modal = _interopRequireDefault(require("./modal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var popupOpenBtns = document.querySelectorAll('[data-toggle="modal"]') || [];
popupOpenBtns.forEach(function (btn) {
  new _modal["default"](btn);
});

},{"./modal":22}],24:[function(require,module,exports){
"use strict";

var _globalFunctions = require("./global-functions");

var linksToPartners = document.querySelectorAll('.partners-list__link');

var onLinkMouseOver = function onLinkMouseOver(evt) {
  var currentLink = evt.target;
  setTimeout(function () {
    currentLink.classList.remove('unhover');
  }, 0);
  currentLink.addEventListener('mouseout', function () {
    currentLink.classList.add('unhover');
  });
};

if (!(0, _globalFunctions.isMobileDevice)()) {
  linksToPartners.forEach(function (link) {
    setTimeout(function () {
      link.addEventListener('mouseover', onLinkMouseOver);
    }, 0);
  });
}

},{"./global-functions":13}],25:[function(require,module,exports){
"use strict";

/**
 * @link: https://gist.github.com/k-gun/c2ea7c49edf7b757fe9561ba37cb19ca
 */
// helpers
var regExp = function regExp(name) {
  return new RegExp('(^| )' + name + '( |$)');
};

var forEach = function forEach(list, fn, scope) {
  for (var i = 0; i < list.length; i++) {
    fn.call(scope, list[i]);
  }
}; // class list object with basic methods


function ClassList(element) {
  this.element = element;
}

ClassList.prototype = {
  add: function add() {
    forEach(arguments, function (name) {
      if (!this.contains(name)) {
        this.element.className += ' ' + name;
      }
    }, this);
  },
  remove: function remove() {
    forEach(arguments, function (name) {
      this.element.className = this.element.className.replace(regExp(name), '');
    }, this);
  },
  toggle: function toggle(name) {
    return this.contains(name) ? (this.remove(name), false) : (this.add(name), true);
  },
  contains: function contains(name) {
    return regExp(name).test(this.element.className);
  },
  // bonus..
  replace: function replace(oldName, newName) {
    this.remove(oldName), this.add(newName);
  }
}; // IE8/9, Safari

if (!('classList' in Element.prototype)) {
  Object.defineProperty(Element.prototype, 'classList', {
    get: function get() {
      return new ClassList(this);
    }
  });
} // replace() support for others


if (window.DOMTokenList && DOMTokenList.prototype.replace == null) {
  DOMTokenList.prototype.replace = ClassList.prototype.replace;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (css) {
    var node = this;

    while (node) {
      if (node.matches(css)) return node;else node = node.parentElement;
    }

    return null;
  };
}

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector;
}

if ('NodeList' in window && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;

    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
} // fix "background-attachment: fixed;" bugs ie


if (navigator.userAgent.match(/Trident\/7\./)) {
  document.body.addEventListener('mousewheel', function () {
    event.preventDefault();
    var wd = event.wheelDelta;
    var csp = window.pageYOffset;
    window.scrollTo(0, csp - wd);
  });
}

},{}],26:[function(require,module,exports){
"use strict";

var MOBILE_BREAKPOINT = 1200;
var HEADER_GAP = 200;
var header = document.querySelector('.header');
var headerOffset = 0; // scroll position on which header appearance depends

var scrolled = 0; // scroll direction

var down = true;

var updateHeaderOffset = function updateHeaderOffset() {
  headerOffset = Number(window.getComputedStyle(header, null).getPropertyValue('padding-top').replace(/[^\d]/g, ''));
};

var resetHeaderState = function resetHeaderState() {
  header.classList.remove('header--gap');
  header.classList.remove('header--in');
  header.classList.remove('header--active');
  scrolled = window.scrollY || window.pageYOffset;
  down = true;
};

var processScroll = function processScroll() {
  var scroll = window.scrollY || window.pageYOffset;
  var isMenuOpened = document.querySelector('.menu__item.open') || document.querySelector('.search.open'); // desktop header

  if (window.innerWidth >= MOBILE_BREAKPOINT) {
    if (scroll >= headerOffset) {
      if (!isMenuOpened) {
        header.classList.add('header--active');
      }

      header.classList.add('header--scrolled');
      document.body.classList.add('scrolled');
    } else {
      if (!isMenuOpened) {
        header.classList.remove('header--active');
      }

      header.classList.remove('header--scrolled');
      document.body.classList.remove('scrolled');
    }
  } // mobile header


  if (window.innerWidth < MOBILE_BREAKPOINT) {
    if (scroll <= headerOffset) {
      resetHeaderState();
    }

    if (scroll > HEADER_GAP) {
      header.classList.add('header--active');
      setTimeout(function () {
        header.classList.add('header--gap');
      }, 0);

      if (scroll >= scrolled + HEADER_GAP && header.classList.contains('header--in')) {
        header.classList.remove('header--in');
        down = true;
      } else if (scroll < scrolled - HEADER_GAP && !header.classList.contains('header--in')) {
        header.classList.add('header--in');
        down = false;
      }
    } // set scroll last position depending on scroll direction


    if (down && scroll > scrolled) {
      scrolled = scroll;
    } else if (!down && scroll < scrolled) {
      scrolled = scroll;
    }
  }
};

window.addEventListener('scroll', processScroll);
window.addEventListener('touchmove', processScroll);
window.addEventListener('resize', function () {
  resetHeaderState();
  updateHeaderOffset();
  processScroll();
});
resetHeaderState();
updateHeaderOffset();
processScroll();

},{}],27:[function(require,module,exports){
"use strict";

var aside = document.querySelector('.title-block__container');
var asideMenu = document.querySelector('.title-block__aside');
var socials = document.querySelector('[data-toggle="socials-scroll"]');
var headerHeight = document.querySelector('.header').clientHeight;

if (aside) {
  var topScroll = Number(window.getComputedStyle(aside, null).getPropertyValue('padding-top').replace(/[^\d]/g, ''));

  var asideMenuInit = function asideMenuInit() {
    window.addEventListener('scroll', function () {
      var scroll = window.scrollY || window.pageYOffset;

      if (asideMenu) {
        if (scroll >= topScroll - headerHeight) {
          asideMenu.classList.add('scroll');
        } else {
          asideMenu.classList.remove('scroll');
        }
      }

      if (socials) {
        if (scroll >= topScroll - headerHeight) {
          socials.classList.add('scroll');

          if (aside.clientWidth >= 1410) {
            socials.classList.add('align-right');
          }
        } else {
          socials.classList.remove('scroll');
          socials.classList.remove('align-right');
        }
      }
    });
  };

  asideMenuInit();
  window.addEventListener('resize', asideMenuInit);
}

},{}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetSubmenu = void 0;
var submenuItems = document.querySelectorAll('[data-toggle="open-submenu"]');
var submenuDefault = document.querySelector('[data-menu-type="submenu"]');
var leftMenu = document.querySelector('[data-type="submenu"]');
var currentHeightSubmenu,
    activeSubmenuLink,
    activeSubmenu = submenuDefault;
submenuItems.forEach(function (link) {
  link.addEventListener('mouseenter', function (evt) {
    var newLink = evt.target;
    var id = newLink.getAttribute('data-target');
    var newSubmenu = document.querySelector('#' + id);
    var offsetHeightLeftMenu = leftMenu.offsetHeight + leftMenu.offsetTop;
    var offsetHeightDefaultSubmenu = submenuDefault.offsetHeight + submenuDefault.offsetTop;

    if (!currentHeightSubmenu) {
      currentHeightSubmenu = offsetHeightLeftMenu > offsetHeightDefaultSubmenu ? offsetHeightLeftMenu : offsetHeightDefaultSubmenu;
    }

    if (activeSubmenu !== newSubmenu) {
      if (activeSubmenu) {
        activeSubmenu.classList.remove('open');
        activeSubmenu.removeAttribute('style');
      }

      if (activeSubmenuLink) {
        activeSubmenuLink.classList.remove('active');
      }

      newLink.classList.add('active');
      newSubmenu.classList.add('open');
      var offsetHeightNewSubmenu = newSubmenu.offsetHeight + newSubmenu.offsetTop;

      if (offsetHeightNewSubmenu !== currentHeightSubmenu) {
        newSubmenu.style.height = currentHeightSubmenu + 'px';
        setTimeout(function () {
          newSubmenu.style.height = offsetHeightNewSubmenu + 'px';
        }, 0);

        if (offsetHeightLeftMenu > offsetHeightNewSubmenu) {
          currentHeightSubmenu = offsetHeightLeftMenu;
        } else {
          currentHeightSubmenu = offsetHeightNewSubmenu;
        }
      }

      activeSubmenu = newSubmenu;
      activeSubmenuLink = newLink;
    }
  });
});

var resetSubmenu = function resetSubmenu() {
  var submenus = document.querySelectorAll('[data-menu-type="submenu"].open');
  var submenuItems = document.querySelectorAll('[data-toggle="open-submenu"].active');
  submenus.forEach(function (submenu) {
    submenu.classList.remove('open');
  });
  submenuItems.forEach(function (item) {
    item.classList.remove('active');
  });
  submenuDefault.classList.add('open');
  activeSubmenu = submenuDefault;
};

exports.resetSubmenu = resetSubmenu;

},{}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ajaxHandler = _interopRequireDefault(require("../app/ajax-handler"));

var _filterizr = _interopRequireDefault(require("filterizr"));

var _filter = require("../app/filter");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var LoadMore = /*#__PURE__*/function () {
  function LoadMore(btn) {
    _classCallCheck(this, LoadMore);

    var attributes = btn.attributes;
    /**
     * Options array
     *   termId
     *   postType
     *   numberposts
     *   offset
     *
     * Usage: 'data-loadmore-%option%="%value%"'
     * NB: %option% should be written in kebab-case (postType => data-loadmore-post-type)
     *
     * @type {{action: string}}
     */

    this.options = {
      'action': 'load_more'
    };

    for (var i = attributes.length - 1; i >= 0; i--) {
      if (attributes[i].name.indexOf('data-loadmore-') === -1) continue;
      var attributeName = attributes[i].name.replace('data-loadmore-', '').split('-').reduce(function (finalName, namePart, index) {
        return finalName + (index === 0 ? namePart : namePart.charAt(0).toUpperCase() + namePart.slice(1));
      });
      this.options[attributeName] = attributes[i].value;
    }

    this.options['offset'] = this.options['offset'] ? this.options['offset'] : this.options['numberposts'] ? this.options['numberposts'] : '';
    this.btn = btn;
    this.ajaxContainer = this.btn.closest('.loadmore-wrap').querySelector('.loadmore-container');

    this._setListeners();
  }

  _createClass(LoadMore, [{
    key: "_setListeners",
    value: function _setListeners() {
      var _this = this;

      this.btn.addEventListener('click', function () {
        return _this._load();
      });
    }
  }, {
    key: "_load",
    value: function _load() {
      var _this2 = this;

      var data = new FormData();

      for (var prop in this.options) {
        data.append(prop, this.options[prop]);
      }

      var ajaxHandler = new _ajaxHandler["default"]({
        'url': '/wp-admin/admin-ajax.php'
      });
      ajaxHandler.send(data, function () {
        var response = ajaxHandler.response;

        _this2.ajaxContainer.insertAdjacentHTML('beforeend', response.posts);

        if (response['morePosts']) {
          _this2.options['offset'] = response['currentOffset'];
        } else {
          _this2.btn.style.display = 'none';
        } //TODO: find the way to append items to filter without destroy


        if (_this2.ajaxContainer.classList.contains('filter-container')) {
          // const doc = new DOMParser().parseFromString(`<div>${response.posts}</div>`, "text/xml");
          // const items = doc.querySelectorAll('.filtr-item');
          // items.forEach(item => {
          //   console.log(item);
          //   filter.insertItem(item)
          // });
          _filter.filter.destroy();

          new _filterizr["default"](_this2.ajaxContainer, _filter.filterOptions);
        }
      });
    }
  }]);

  return LoadMore;
}();

var _default = LoadMore;
exports["default"] = _default;

},{"../app/ajax-handler":6,"../app/filter":10,"filterizr":2}],30:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/*!
 * Glide.js v3.3.0
 * (c) 2013-2019 Jędrzej Chałubek <jedrzej.chalubek@gmail.com> (http://jedrzejchalubek.com/)
 * Released under the MIT License.
 */
!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.Glide = e();
}(void 0, function () {
  "use strict";

  var n = {
    type: "slider",
    startAt: 0,
    perView: 1,
    focusAt: 0,
    gap: 10,
    autoplay: !1,
    hoverpause: !0,
    keyboard: !0,
    bound: !1,
    swipeThreshold: 80,
    dragThreshold: 120,
    perSwipe: "|",
    touchRatio: .5,
    touchAngle: 45,
    animationDuration: 400,
    rewind: !0,
    rewindDuration: 800,
    animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)",
    waitForTransition: !0,
    throttle: 10,
    direction: "ltr",
    peek: 0,
    breakpoints: {},
    classes: {
      swipeable: "glide--swipeable",
      dragging: "glide--dragging",
      direction: {
        ltr: "glide--ltr",
        rtl: "glide--rtl"
      },
      type: {
        slider: "glide--slider",
        carousel: "glide--carousel"
      },
      slide: {
        clone: "glide__slide--clone",
        active: "glide__slide--active"
      },
      arrow: {
        disabled: "glide__arrow--disabled"
      },
      nav: {
        active: "glide__bullet--active"
      }
    }
  };

  function i(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }

  var r = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
    return _typeof(t);
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
  },
      t = function t(_t, e, n) {
    return e && s(_t.prototype, e), n && s(_t, n), _t;
  };

  function s(t, e) {
    for (var n = 0; n < e.length; n++) {
      var i = e[n];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }

  var a = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var i in n) {
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
      }
    }

    return t;
  };

  function y(t) {
    return parseInt(t);
  }

  function o(t) {
    return "string" == typeof t;
  }

  function u(t) {
    var e = void 0 === t ? "undefined" : r(t);
    return "function" === e || "object" === e && !!t;
  }

  function c(t) {
    return "function" == typeof t;
  }

  function l(t) {
    return void 0 === t;
  }

  function f(t) {
    return t.constructor === Array;
  }

  function d(t, e, n) {
    Object.defineProperty(t, e, n);
  }

  function h(t, e) {
    var n = a({}, t, e);
    return e.hasOwnProperty("classes") && (n.classes = a({}, t.classes, e.classes), e.classes.hasOwnProperty("direction") && (n.classes.direction = a({}, t.classes.direction, e.classes.direction)), e.classes.hasOwnProperty("type") && (n.classes.type = a({}, t.classes.type, e.classes.type)), e.classes.hasOwnProperty("slide") && (n.classes.slide = a({}, t.classes.slide, e.classes.slide)), e.classes.hasOwnProperty("arrow") && (n.classes.arrow = a({}, t.classes.arrow, e.classes.arrow)), e.classes.hasOwnProperty("nav") && (n.classes.nav = a({}, t.classes.nav, e.classes.nav))), e.hasOwnProperty("breakpoints") && (n.breakpoints = a({}, t.breakpoints, e.breakpoints)), n;
  }

  var v = (t(e, [{
    key: "on",
    value: function value(t, e) {
      if (f(t)) for (var n = 0; n < t.length; n++) {
        this.on(t[n], e);
      }
      this.hop.call(this.events, t) || (this.events[t] = []);
      var i = this.events[t].push(e) - 1;
      return {
        remove: function remove() {
          delete this.events[t][i];
        }
      };
    }
  }, {
    key: "emit",
    value: function value(t, e) {
      if (f(t)) for (var n = 0; n < t.length; n++) {
        this.emit(t[n], e);
      }
      this.hop.call(this.events, t) && this.events[t].forEach(function (t) {
        t(e || {});
      });
    }
  }]), e);

  function e() {
    var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
    i(this, e), this.events = t, this.hop = t.hasOwnProperty;
  }

  var p = (t(m, [{
    key: "mount",
    value: function value(t) {
      var e = 0 < arguments.length && void 0 !== t ? t : {};
      return this._e.emit("mount.before"), u(e) && (this._c = function (t, e, n) {
        var i = {};

        for (var r in e) {
          c(e[r]) && (i[r] = e[r](t, i, n));
        }

        for (var s in i) {
          c(i[s].mount) && i[s].mount();
        }

        return i;
      }(this, e, this._e)), this._e.emit("mount.after"), this;
    }
  }, {
    key: "mutate",
    value: function value(t) {
      var e = 0 < arguments.length && void 0 !== t ? t : [];
      return f(e) && (this._t = e), this;
    }
  }, {
    key: "update",
    value: function value(t) {
      var e = 0 < arguments.length && void 0 !== t ? t : {};
      return this.settings = h(this.settings, e), e.hasOwnProperty("startAt") && (this.index = e.startAt), this._e.emit("update"), this;
    }
  }, {
    key: "go",
    value: function value(t) {
      return this._c.Run.make(t), this;
    }
  }, {
    key: "move",
    value: function value(t) {
      return this._c.Transition.disable(), this._c.Move.make(t), this;
    }
  }, {
    key: "destroy",
    value: function value() {
      return this._e.emit("destroy"), this;
    }
  }, {
    key: "play",
    value: function value(t) {
      var e = 0 < arguments.length && void 0 !== t && t;
      return e && (this.settings.autoplay = e), this._e.emit("play"), this;
    }
  }, {
    key: "pause",
    value: function value() {
      return this._e.emit("pause"), this;
    }
  }, {
    key: "disable",
    value: function value() {
      return this.disabled = !0, this;
    }
  }, {
    key: "enable",
    value: function value() {
      return this.disabled = !1, this;
    }
  }, {
    key: "on",
    value: function value(t, e) {
      return this._e.on(t, e), this;
    }
  }, {
    key: "isType",
    value: function value(t) {
      return this.settings.type === t;
    }
  }, {
    key: "settings",
    get: function get() {
      return this._o;
    },
    set: function set(t) {
      u(t) && (this._o = t);
    }
  }, {
    key: "index",
    get: function get() {
      return this._i;
    },
    set: function set(t) {
      this._i = y(t);
    }
  }, {
    key: "type",
    get: function get() {
      return this.settings.type;
    }
  }, {
    key: "disabled",
    get: function get() {
      return this._d;
    },
    set: function set(t) {
      this._d = !!t;
    }
  }]), m);

  function m(t) {
    var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
    i(this, m), this._c = {}, this._t = [], this._e = new v(), this.disabled = !1, this.selector = t, this.settings = h(n, e), this.index = this.settings.startAt;
  }

  function g() {
    return new Date().getTime();
  }

  function b(n, i, r) {
    var s = void 0,
        o = void 0,
        u = void 0,
        a = void 0,
        c = 0;
    r = r || {};

    function l() {
      c = !1 === r.leading ? 0 : g(), s = null, a = n.apply(o, u), s || (o = u = null);
    }

    function t() {
      var t = g();
      c || !1 !== r.leading || (c = t);
      var e = i - (t - c);
      return o = this, u = arguments, e <= 0 || i < e ? (s && (clearTimeout(s), s = null), c = t, a = n.apply(o, u), s || (o = u = null)) : s || !1 === r.trailing || (s = setTimeout(l, e)), a;
    }

    return t.cancel = function () {
      clearTimeout(s), c = 0, s = o = u = null;
    }, t;
  }

  var w = {
    ltr: ["marginLeft", "marginRight"],
    rtl: ["marginRight", "marginLeft"]
  };

  function _(t) {
    if (t && t.parentNode) {
      for (var e = t.parentNode.firstChild, n = []; e; e = e.nextSibling) {
        1 === e.nodeType && e !== t && n.push(e);
      }

      return n;
    }

    return [];
  }

  function k(t) {
    return !!(t && t instanceof window.HTMLElement);
  }

  var S = '[data-glide-el="track"]';
  var H = (t(T, [{
    key: "on",
    value: function value(t, e, n, i) {
      var r = 3 < arguments.length && void 0 !== i && i;
      o(t) && (t = [t]);

      for (var s = 0; s < t.length; s++) {
        this.listeners[t[s]] = n, e.addEventListener(t[s], this.listeners[t[s]], r);
      }
    }
  }, {
    key: "off",
    value: function value(t, e, n) {
      var i = 2 < arguments.length && void 0 !== n && n;
      o(t) && (t = [t]);

      for (var r = 0; r < t.length; r++) {
        e.removeEventListener(t[r], this.listeners[t[r]], i);
      }
    }
  }, {
    key: "destroy",
    value: function value() {
      delete this.listeners;
    }
  }]), T);

  function T() {
    var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
    i(this, T), this.listeners = t;
  }

  var O = ["ltr", "rtl"],
      x = {
    ">": "<",
    "<": ">",
    "=": "="
  };

  function A(t, e) {
    return {
      modify: function modify(t) {
        return e.Direction.is("rtl") ? -t : t;
      }
    };
  }

  function P(i, r, s) {
    var o = [function (t, n) {
      return {
        modify: function modify(t) {
          var e = Math.floor(t / n.Sizes.slideWidth);
          return t + n.Gaps.value * e;
        }
      };
    }, function (t, e) {
      return {
        modify: function modify(t) {
          return t + e.Clones.grow / 2;
        }
      };
    }, function (n, i) {
      return {
        modify: function modify(t) {
          if (0 <= n.settings.focusAt) {
            var e = i.Peek.value;
            return u(e) ? t - e.before : t - e;
          }

          return t;
        }
      };
    }, function (s, o) {
      return {
        modify: function modify(t) {
          var e = o.Gaps.value,
              n = o.Sizes.width,
              i = s.settings.focusAt,
              r = o.Sizes.slideWidth;
          return "center" === i ? t - (n / 2 - r / 2) : t - r * i - e * i;
        }
      };
    }].concat(i._t, [A]);
    return {
      mutate: function mutate(t) {
        for (var e = 0; e < o.length; e++) {
          var n = o[e];
          c(n) && c(n().modify) && (t = n(i, r, s).modify(t));
        }

        return t;
      }
    };
  }

  var M = !1;

  try {
    var z = Object.defineProperty({}, "passive", {
      get: function get() {
        M = !0;
      }
    });
    window.addEventListener("testPassive", null, z), window.removeEventListener("testPassive", null, z);
  } catch (t) {}

  var C = M,
      L = ["touchstart", "mousedown"],
      R = ["touchmove", "mousemove"],
      D = ["touchend", "touchcancel", "mouseup", "mouseleave"],
      E = ["mousedown", "mousemove", "mouseup", "mouseleave"];

  function j(t) {
    return u(t) ? function (n) {
      return Object.keys(n).sort().reduce(function (t, e) {
        return t[e] = n[e], t[e], t;
      }, {});
    }(t) : {};
  }

  var W = {
    Html: function Html(e, t) {
      var n = {
        mount: function mount() {
          this.root = e.selector, this.track = this.root.querySelector(S), this.slides = Array.prototype.slice.call(this.wrapper.children).filter(function (t) {
            return !t.classList.contains(e.settings.classes.slide.clone);
          });
        }
      };
      return d(n, "root", {
        get: function get() {
          return n._r;
        },
        set: function set(t) {
          o(t) && (t = document.querySelector(t)), k(t) && (n._r = t);
        }
      }), d(n, "track", {
        get: function get() {
          return n._t;
        },
        set: function set(t) {
          k(t) && (n._t = t);
        }
      }), d(n, "wrapper", {
        get: function get() {
          return n.track.children[0];
        }
      }), n;
    },
    Translate: function Translate(i, r, n) {
      var s = {
        set: function set(t) {
          var e = P(i, r).mutate(t);
          r.Html.wrapper.style.transform = "translate3d(" + -1 * e + "px, 0px, 0px)";
        },
        remove: function remove() {
          r.Html.wrapper.style.transform = "";
        },
        getStartIndex: function getStartIndex() {
          var t = r.Sizes.length,
              e = i.index,
              n = i.settings.perView;
          return r.Run.isOffset(">") || r.Run.isOffset("|>") ? t + (e - n) : (e + n) % t;
        },
        getTravelDistance: function getTravelDistance() {
          var t = r.Sizes.slideWidth * i.settings.perView;
          return r.Run.isOffset(">") || r.Run.isOffset("|>") ? -1 * t : t;
        }
      };
      return n.on("move", function (t) {
        if (!i.isType("carousel") || !r.Run.isOffset()) return s.set(t.movement);
        r.Transition.after(function () {
          n.emit("translate.jump"), s.set(r.Sizes.slideWidth * i.index);
        });
        var e = r.Sizes.slideWidth * r.Translate.getStartIndex();
        return s.set(e - r.Translate.getTravelDistance());
      }), n.on("destroy", function () {
        s.remove();
      }), s;
    },
    Transition: function Transition(n, i, t) {
      var r = !1,
          e = {
        compose: function compose(t) {
          var e = n.settings;
          return r ? t + " 0ms " + e.animationTimingFunc : t + " " + this.duration + "ms " + e.animationTimingFunc;
        },
        set: function set(t) {
          var e = 0 < arguments.length && void 0 !== t ? t : "transform";
          i.Html.wrapper.style.transition = this.compose(e);
        },
        remove: function remove() {
          i.Html.wrapper.style.transition = "";
        },
        after: function after(t) {
          setTimeout(function () {
            t();
          }, this.duration);
        },
        enable: function enable() {
          r = !1, this.set();
        },
        disable: function disable() {
          r = !0, this.set();
        }
      };
      return d(e, "duration", {
        get: function get() {
          var t = n.settings;
          return n.isType("slider") && i.Run.offset ? t.rewindDuration : t.animationDuration;
        }
      }), t.on("move", function () {
        e.set();
      }), t.on(["build.before", "resize", "translate.jump"], function () {
        e.disable();
      }), t.on("run", function () {
        e.enable();
      }), t.on("destroy", function () {
        e.remove();
      }), e;
    },
    Direction: function Direction(t, e, n) {
      var i = {
        mount: function mount() {
          this.value = t.settings.direction;
        },
        resolve: function resolve(t) {
          var e = t.slice(0, 1);
          return this.is("rtl") ? t.split(e).join(x[e]) : t;
        },
        is: function is(t) {
          return this.value === t;
        },
        addClass: function addClass() {
          e.Html.root.classList.add(t.settings.classes.direction[this.value]);
        },
        removeClass: function removeClass() {
          e.Html.root.classList.remove(t.settings.classes.direction[this.value]);
        }
      };
      return d(i, "value", {
        get: function get() {
          return i._v;
        },
        set: function set(t) {
          -1 < O.indexOf(t) && (i._v = t);
        }
      }), n.on(["destroy", "update"], function () {
        i.removeClass();
      }), n.on("update", function () {
        i.mount();
      }), n.on(["build.before", "update"], function () {
        i.addClass();
      }), i;
    },
    Peek: function Peek(n, t, e) {
      var i = {
        mount: function mount() {
          this.value = n.settings.peek;
        }
      };
      return d(i, "value", {
        get: function get() {
          return i._v;
        },
        set: function set(t) {
          u(t) ? (t.before = y(t.before), t.after = y(t.after)) : t = y(t), i._v = t;
        }
      }), d(i, "reductor", {
        get: function get() {
          var t = i.value,
              e = n.settings.perView;
          return u(t) ? t.before / e + t.after / e : 2 * t / e;
        }
      }), e.on(["resize", "update"], function () {
        i.mount();
      }), i;
    },
    Sizes: function Sizes(t, i, e) {
      var n = {
        setupSlides: function setupSlides() {
          for (var t = this.slideWidth + "px", e = i.Html.slides, n = 0; n < e.length; n++) {
            e[n].style.width = t;
          }
        },
        setupWrapper: function setupWrapper() {
          i.Html.wrapper.style.width = this.wrapperSize + "px";
        },
        remove: function remove() {
          for (var t = i.Html.slides, e = 0; e < t.length; e++) {
            t[e].style.width = "";
          }

          i.Html.wrapper.style.width = "";
        }
      };
      return d(n, "length", {
        get: function get() {
          return i.Html.slides.length;
        }
      }), d(n, "width", {
        get: function get() {
          return i.Html.root.offsetWidth;
        }
      }), d(n, "wrapperSize", {
        get: function get() {
          return n.slideWidth * n.length + i.Gaps.grow + i.Clones.grow;
        }
      }), d(n, "slideWidth", {
        get: function get() {
          return n.width / t.settings.perView - i.Peek.reductor - i.Gaps.reductor;
        }
      }), e.on(["build.before", "resize", "update"], function () {
        n.setupSlides(), n.setupWrapper();
      }), e.on("destroy", function () {
        n.remove();
      }), n;
    },
    Gaps: function Gaps(e, s, t) {
      var n = {
        apply: function apply(t) {
          for (var e = 0, n = t.length; e < n; e++) {
            var i = t[e].style,
                r = s.Direction.value;
            i[w[r][0]] = 0 !== e ? this.value / 2 + "px" : "", e !== t.length - 1 ? i[w[r][1]] = this.value / 2 + "px" : i[w[r][1]] = "";
          }
        },
        remove: function remove(t) {
          for (var e = 0, n = t.length; e < n; e++) {
            var i = t[e].style;
            i.marginLeft = "", i.marginRight = "";
          }
        }
      };
      return d(n, "value", {
        get: function get() {
          return y(e.settings.gap);
        }
      }), d(n, "grow", {
        get: function get() {
          return n.value * s.Sizes.length;
        }
      }), d(n, "reductor", {
        get: function get() {
          var t = e.settings.perView;
          return n.value * (t - 1) / t;
        }
      }), t.on(["build.after", "update"], b(function () {
        n.apply(s.Html.wrapper.children);
      }, 30)), t.on("destroy", function () {
        n.remove(s.Html.wrapper.children);
      }), n;
    },
    Move: function Move(t, i, r) {
      var e = {
        mount: function mount() {
          this._o = 0;
        },
        make: function make(t) {
          var e = this,
              n = 0 < arguments.length && void 0 !== t ? t : 0;
          this.offset = n, r.emit("move", {
            movement: this.value
          }), i.Transition.after(function () {
            r.emit("move.after", {
              movement: e.value
            });
          });
        }
      };
      return d(e, "offset", {
        get: function get() {
          return e._o;
        },
        set: function set(t) {
          e._o = l(t) ? 0 : y(t);
        }
      }), d(e, "translate", {
        get: function get() {
          return i.Sizes.slideWidth * t.index;
        }
      }), d(e, "value", {
        get: function get() {
          var t = this.offset,
              e = this.translate;
          return i.Direction.is("rtl") ? e + t : e - t;
        }
      }), r.on(["build.before", "run"], function () {
        e.make();
      }), e;
    },
    Clones: function Clones(v, p, t) {
      var e = {
        mount: function mount() {
          this.items = [], v.isType("carousel") && (this.items = this.collect());
        },
        collect: function collect(t) {
          for (var e = 0 < arguments.length && void 0 !== t ? t : [], n = p.Html.slides, i = v.settings, r = i.perView, s = i.classes, o = r + +!!v.settings.peek + Math.round(r / 2), u = n.slice(0, o).reverse(), a = n.slice(-1 * o), c = 0; c < Math.max(1, Math.floor(r / n.length)); c++) {
            for (var l = 0; l < u.length; l++) {
              var f = u[l].cloneNode(!0);
              f.classList.add(s.slide.clone), e.push(f);
            }

            for (var d = 0; d < a.length; d++) {
              var h = a[d].cloneNode(!0);
              h.classList.add(s.slide.clone), e.unshift(h);
            }
          }

          return e;
        },
        append: function append() {
          for (var t = this.items, e = p.Html, n = e.wrapper, i = e.slides, r = Math.floor(t.length / 2), s = t.slice(0, r).reverse(), o = t.slice(-1 * r).reverse(), u = p.Sizes.slideWidth + "px", a = 0; a < o.length; a++) {
            n.appendChild(o[a]);
          }

          for (var c = 0; c < s.length; c++) {
            n.insertBefore(s[c], i[0]);
          }

          for (var l = 0; l < t.length; l++) {
            t[l].style.width = u;
          }
        },
        remove: function remove() {
          for (var t = this.items, e = 0; e < t.length; e++) {
            p.Html.wrapper.removeChild(t[e]);
          }
        }
      };
      return d(e, "grow", {
        get: function get() {
          return (p.Sizes.slideWidth + p.Gaps.value) * e.items.length;
        }
      }), t.on("update", function () {
        e.remove(), e.mount(), e.append();
      }), t.on("build.before", function () {
        v.isType("carousel") && e.append();
      }), t.on("destroy", function () {
        e.remove();
      }), e;
    },
    Resize: function Resize(t, e, n) {
      var i = new H(),
          r = {
        mount: function mount() {
          this.bind();
        },
        bind: function bind() {
          i.on("resize", window, b(function () {
            n.emit("resize");
          }, t.settings.throttle));
        },
        unbind: function unbind() {
          i.off("resize", window);
        }
      };
      return n.on("destroy", function () {
        r.unbind(), i.destroy();
      }), r;
    },
    Build: function Build(i, r, t) {
      var e = {
        mount: function mount() {
          t.emit("build.before"), this.typeClass(), this.activeClass(), t.emit("build.after");
        },
        typeClass: function typeClass() {
          r.Html.root.classList.add(i.settings.classes.type[i.settings.type]);
        },
        activeClass: function activeClass() {
          var e = i.settings.classes,
              t = r.Html.slides[i.index];
          t && (t.classList.add(e.slide.active), _(t).forEach(function (t) {
            t.classList.remove(e.slide.active);
          }));
        },
        removeClasses: function removeClasses() {
          var t = i.settings.classes,
              e = t.type,
              n = t.slide;
          r.Html.root.classList.remove(e[i.settings.type]), r.Html.slides.forEach(function (t) {
            t.classList.remove(n.active);
          });
        }
      };
      return t.on(["destroy", "update"], function () {
        e.removeClasses();
      }), t.on(["resize", "update"], function () {
        e.mount();
      }), t.on("move.after", function () {
        e.activeClass();
      }), e;
    },
    Run: function Run(u, n, i) {
      var a = {
        mount: function mount() {
          this._o = !1;
        },
        make: function make(t) {
          var e = this;
          u.disabled || (u.settings.waitForTransition && u.disable(), this.move = t, i.emit("run.before", this.move), this.calculate(), i.emit("run", this.move), n.Transition.after(function () {
            e.isStart() && i.emit("run.start", e.move), e.isEnd() && i.emit("run.end", e.move), e.isOffset() && (e._o = !1, i.emit("run.offset", e.move)), i.emit("run.after", e.move), u.enable();
          }));
        },
        calculate: function calculate() {
          var t = this.move,
              e = this.length,
              n = t.steps,
              i = t.direction,
              r = 1;
          if ("=" !== i) {
            if (">" !== i || ">" !== n) {
              if ("<" !== i || "<" !== n) {
                if ("|" === i && (r = u.settings.perView || 1), ">" === i || "|" === i && ">" === n) {
                  var s = function (t) {
                    var e = u.index;
                    if (u.isType("carousel")) return e + t;
                    return e + (t - e % t);
                  }(r);

                  return e < s && (this._o = !0), void (u.index = function (t, e) {
                    var n = a.length;
                    if (t <= n) return t;
                    if (u.isType("carousel")) return t - (n + 1);
                    if (u.settings.rewind) return a.isBound() && !a.isEnd() ? n : 0;
                    if (a.isBound()) return n;
                    return Math.floor(n / e) * e;
                  }(s, r));
                }

                if ("<" === i || "|" === i && "<" === n) {
                  var o = function (t) {
                    var e = u.index;
                    if (u.isType("carousel")) return e - t;
                    return (Math.ceil(e / t) - 1) * t;
                  }(r);

                  return o < 0 && (this._o = !0), void (u.index = function (t, e) {
                    var n = a.length;
                    if (0 <= t) return t;
                    if (u.isType("carousel")) return t + (n + 1);
                    if (u.settings.rewind) return a.isBound() && a.isStart() ? n : Math.floor(n / e) * e;
                    return 0;
                  }(o, r));
                }
              } else u.index = 0;
            } else u.index = e;
          } else u.index = n;
        },
        isStart: function isStart() {
          return u.index <= 0;
        },
        isEnd: function isEnd() {
          return u.index >= this.length;
        },
        isOffset: function isOffset(t) {
          var e = 0 < arguments.length && void 0 !== t ? t : void 0;
          return e ? !!this._o && ("|>" === e ? "|" === this.move.direction && ">" === this.move.steps : "|<" === e ? "|" === this.move.direction && "<" === this.move.steps : this.move.direction === e) : this._o;
        },
        isBound: function isBound() {
          return u.isType("slider") && "center" !== u.settings.focusAt && u.settings.bound;
        }
      };
      return d(a, "move", {
        get: function get() {
          return this._m;
        },
        set: function set(t) {
          var e = t.substr(1);
          this._m = {
            direction: t.substr(0, 1),
            steps: e ? y(e) ? y(e) : e : 0
          };
        }
      }), d(a, "length", {
        get: function get() {
          var t = u.settings,
              e = n.Html.slides.length;
          return this.isBound() ? e - 1 - (y(t.perView) - 1) + y(t.focusAt) : e - 1;
        }
      }), d(a, "offset", {
        get: function get() {
          return this._o;
        }
      }), a;
    },
    Swipe: function Swipe(d, h, v) {
      var r = new H(),
          p = 0,
          m = 0,
          g = 0,
          n = !1,
          s = !!C && {
        passive: !0
      },
          t = {
        mount: function mount() {
          this.bindSwipeStart();
        },
        start: function start(t) {
          if (!n && !d.disabled) {
            this.disable();
            var e = this.touches(t);
            p = null, m = y(e.pageX), g = y(e.pageY), this.bindSwipeMove(), this.bindSwipeEnd(), v.emit("swipe.start");
          }
        },
        move: function move(t) {
          if (!d.disabled) {
            var e = d.settings,
                n = e.touchAngle,
                i = e.touchRatio,
                r = e.classes,
                s = this.touches(t),
                o = y(s.pageX) - m,
                u = y(s.pageY) - g,
                a = Math.abs(o << 2),
                c = Math.abs(u << 2),
                l = Math.sqrt(a + c),
                f = Math.sqrt(c);
            if (!(180 * (p = Math.asin(f / l)) / Math.PI < n)) return !1;
            t.stopPropagation(), h.Move.make(o * function (t) {
              return parseFloat(t);
            }(i)), h.Html.root.classList.add(r.dragging), v.emit("swipe.move");
          }
        },
        end: function end(t) {
          if (!d.disabled) {
            var e = d.settings,
                n = e.perSwipe,
                i = e.touchAngle,
                r = e.classes,
                s = this.touches(t),
                o = this.threshold(t),
                u = s.pageX - m,
                a = 180 * p / Math.PI;
            this.enable(), o < u && a < i ? h.Run.make(h.Direction.resolve(n + "<")) : u < -o && a < i ? h.Run.make(h.Direction.resolve(n + ">")) : h.Move.make(), h.Html.root.classList.remove(r.dragging), this.unbindSwipeMove(), this.unbindSwipeEnd(), v.emit("swipe.end");
          }
        },
        bindSwipeStart: function bindSwipeStart() {
          var e = this,
              t = d.settings,
              n = t.swipeThreshold,
              i = t.dragThreshold;
          n && r.on(L[0], h.Html.wrapper, function (t) {
            e.start(t);
          }, s), i && r.on(L[1], h.Html.wrapper, function (t) {
            e.start(t);
          }, s);
        },
        unbindSwipeStart: function unbindSwipeStart() {
          r.off(L[0], h.Html.wrapper, s), r.off(L[1], h.Html.wrapper, s);
        },
        bindSwipeMove: function bindSwipeMove() {
          var e = this;
          r.on(R, h.Html.wrapper, b(function (t) {
            e.move(t);
          }, d.settings.throttle), s);
        },
        unbindSwipeMove: function unbindSwipeMove() {
          r.off(R, h.Html.wrapper, s);
        },
        bindSwipeEnd: function bindSwipeEnd() {
          var e = this;
          r.on(D, h.Html.wrapper, function (t) {
            e.end(t);
          });
        },
        unbindSwipeEnd: function unbindSwipeEnd() {
          r.off(D, h.Html.wrapper);
        },
        touches: function touches(t) {
          return -1 < E.indexOf(t.type) ? t : t.touches[0] || t.changedTouches[0];
        },
        threshold: function threshold(t) {
          var e = d.settings;
          return -1 < E.indexOf(t.type) ? e.dragThreshold : e.swipeThreshold;
        },
        enable: function enable() {
          return n = !1, h.Transition.enable(), this;
        },
        disable: function disable() {
          return n = !0, h.Transition.disable(), this;
        }
      };
      return v.on("build.after", function () {
        h.Html.root.classList.add(d.settings.classes.swipeable);
      }), v.on("destroy", function () {
        t.unbindSwipeStart(), t.unbindSwipeMove(), t.unbindSwipeEnd(), r.destroy();
      }), t;
    },
    Images: function Images(t, e, n) {
      var i = new H(),
          r = {
        mount: function mount() {
          this.bind();
        },
        bind: function bind() {
          i.on("dragstart", e.Html.wrapper, this.dragstart);
        },
        unbind: function unbind() {
          i.off("dragstart", e.Html.wrapper);
        },
        dragstart: function dragstart(t) {
          t.preventDefault();
        }
      };
      return n.on("destroy", function () {
        r.unbind(), i.destroy();
      }), r;
    },
    Anchors: function Anchors(t, e, n) {
      var i = new H(),
          r = !1,
          s = !1,
          o = {
        mount: function mount() {
          this._a = e.Html.wrapper.querySelectorAll("a"), this.bind();
        },
        bind: function bind() {
          i.on("click", e.Html.wrapper, this.click);
        },
        unbind: function unbind() {
          i.off("click", e.Html.wrapper);
        },
        click: function click(t) {
          s && (t.stopPropagation(), t.preventDefault());
        },
        detach: function detach() {
          if (s = !0, !r) {
            for (var t = 0; t < this.items.length; t++) {
              this.items[t].draggable = !1, this.items[t].setAttribute("data-href", this.items[t].getAttribute("href")), this.items[t].removeAttribute("href");
            }

            r = !0;
          }

          return this;
        },
        attach: function attach() {
          if (s = !1, r) {
            for (var t = 0; t < this.items.length; t++) {
              this.items[t].draggable = !0, this.items[t].setAttribute("href", this.items[t].getAttribute("data-href"));
            }

            r = !1;
          }

          return this;
        }
      };
      return d(o, "items", {
        get: function get() {
          return o._a;
        }
      }), n.on("swipe.move", function () {
        o.detach();
      }), n.on("swipe.end", function () {
        e.Transition.after(function () {
          o.attach();
        });
      }), n.on("destroy", function () {
        o.attach(), o.unbind(), i.destroy();
      }), o;
    },
    Controls: function Controls(i, e, t) {
      var n = new H(),
          r = !!C && {
        passive: !0
      },
          s = {
        mount: function mount() {
          this._n = e.Html.root.querySelectorAll('[data-glide-el="controls[nav]"]'), this._c = e.Html.root.querySelectorAll('[data-glide-el^="controls"]'), this.addBindings();
        },
        setActive: function setActive() {
          for (var t = 0; t < this._n.length; t++) {
            this.addClass(this._n[t].children);
          }
        },
        removeActive: function removeActive() {
          for (var t = 0; t < this._n.length; t++) {
            this.removeClass(this._n[t].children);
          }
        },
        addClass: function addClass(t) {
          var e = i.settings,
              n = t[i.index];
          n && (n.classList.add(e.classes.nav.active), _(n).forEach(function (t) {
            t.classList.remove(e.classes.nav.active);
          }));
        },
        removeClass: function removeClass(t) {
          var e = t[i.index];
          e && e.classList.remove(i.settings.classes.nav.active);
        },
        addBindings: function addBindings() {
          for (var t = 0; t < this._c.length; t++) {
            this.bind(this._c[t].children);
          }
        },
        removeBindings: function removeBindings() {
          for (var t = 0; t < this._c.length; t++) {
            this.unbind(this._c[t].children);
          }
        },
        bind: function bind(t) {
          for (var e = 0; e < t.length; e++) {
            n.on("click", t[e], this.click), n.on("touchstart", t[e], this.click, r);
          }
        },
        unbind: function unbind(t) {
          for (var e = 0; e < t.length; e++) {
            n.off(["click", "touchstart"], t[e]);
          }
        },
        click: function click(t) {
          t.preventDefault(), e.Run.make(e.Direction.resolve(t.currentTarget.getAttribute("data-glide-dir")));
        }
      };
      return d(s, "items", {
        get: function get() {
          return s._c;
        }
      }), t.on(["mount.after", "move.after"], function () {
        s.setActive();
      }), t.on("destroy", function () {
        s.removeBindings(), s.removeActive(), n.destroy();
      }), s;
    },
    Keyboard: function Keyboard(t, e, n) {
      var i = new H(),
          r = {
        mount: function mount() {
          t.settings.keyboard && this.bind();
        },
        bind: function bind() {
          i.on("keyup", document, this.press);
        },
        unbind: function unbind() {
          i.off("keyup", document);
        },
        press: function press(t) {
          39 === t.keyCode && e.Run.make(e.Direction.resolve(">")), 37 === t.keyCode && e.Run.make(e.Direction.resolve("<"));
        }
      };
      return n.on(["destroy", "update"], function () {
        r.unbind();
      }), n.on("update", function () {
        r.mount();
      }), n.on("destroy", function () {
        i.destroy();
      }), r;
    },
    Autoplay: function Autoplay(e, n, t) {
      var i = new H(),
          r = {
        mount: function mount() {
          this.start(), e.settings.hoverpause && this.bind();
        },
        start: function start() {
          var t = this;
          e.settings.autoplay && l(this._i) && (this._i = setInterval(function () {
            t.stop(), n.Run.make(">"), t.start();
          }, this.time));
        },
        stop: function stop() {
          this._i = clearInterval(this._i);
        },
        bind: function bind() {
          var t = this;
          i.on("mouseover", n.Html.root, function () {
            t.stop();
          }), i.on("mouseout", n.Html.root, function () {
            t.start();
          });
        },
        unbind: function unbind() {
          i.off(["mouseover", "mouseout"], n.Html.root);
        }
      };
      return d(r, "time", {
        get: function get() {
          var t = n.Html.slides[e.index].getAttribute("data-glide-autoplay");
          return y(t || e.settings.autoplay);
        }
      }), t.on(["destroy", "update"], function () {
        r.unbind();
      }), t.on(["run.before", "pause", "destroy", "swipe.start", "update"], function () {
        r.stop();
      }), t.on(["run.after", "play", "swipe.end"], function () {
        r.start();
      }), t.on("update", function () {
        r.mount();
      }), t.on("destroy", function () {
        i.destroy();
      }), r;
    },
    Breakpoints: function Breakpoints(t, e, n) {
      var i = new H(),
          r = t.settings,
          s = j(r.breakpoints),
          o = a({}, r),
          u = {
        match: function match(t) {
          if (void 0 !== window.matchMedia) for (var e in t) {
            if (t.hasOwnProperty(e) && window.matchMedia("(max-width: " + e + "px)").matches) return t[e];
          }
          return o;
        }
      };
      return a(r, u.match(s)), i.on("resize", window, b(function () {
        t.settings = h(r, u.match(s));
      }, t.settings.throttle)), n.on("update", function () {
        s = j(s), o = a({}, r);
      }), n.on("destroy", function () {
        i.off("resize", window);
      }), u;
    }
  };

  function B() {
    return i(this, B), function (t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
    }(this, (B.__proto__ || Object.getPrototypeOf(B)).apply(this, arguments));
  }

  return function (t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
  }(B, p), t(B, [{
    key: "mount",
    value: function value(t) {
      var e = 0 < arguments.length && void 0 !== t ? t : {};
      return function t(e, n, i) {
        null === e && (e = Function.prototype);
        var r = Object.getOwnPropertyDescriptor(e, n);

        if (void 0 === r) {
          var s = Object.getPrototypeOf(e);
          return null === s ? void 0 : t(s, n, i);
        }

        if ("value" in r) return r.value;
        var o = r.get;
        return void 0 !== o ? o.call(i) : void 0;
      }(B.prototype.__proto__ || Object.getPrototypeOf(B.prototype), "mount", this).call(this, a({}, W, e));
    }
  }]), B;
});

},{}]},{},[4]);
